/* Lumi site v2 interactions. No libraries. Everything degrades to a static page.
   Each feature initialises inside a root element, so Shopify's theme editor can re-run it
   for a section it has just re-rendered (see the shopify:section:load hook at the bottom). */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s,r){return (r||document).querySelector(s)};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var buzz = function(ms){ if (!navigator.vibrate) return; if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return; try{navigator.vibrate(ms)}catch(e){} };
  var safe = function(fn){ return function(root){ try { fn(root || document); } catch(e){ if (window.console) console.warn('lumi:', e); } }; };
  var PLAY = '<svg viewBox="0 0 16 16"><path d="M4 2.5v11l9.5-5.5z"/></svg>';
  var PAUSE = '<svg viewBox="0 0 16 16"><rect x="3" y="2" width="3.5" height="12" rx="1"/><rect x="9.5" y="2" width="3.5" height="12" rx="1"/></svg>';

  /* nav: frosted after the hero, hides while scrolling down, back on the way up */
  var nav = $('.nav'), lastY = window.scrollY;
  function onScroll(){
    var y = window.scrollY;
    if (nav){
      nav.classList.toggle('solid', y > 20);
      if (y > 400 && y > lastY + 4) nav.classList.add('hide');
      else if (y <= 400 || y < lastY - 4) nav.classList.remove('hide');
    }
    var bar = $('.mbar');
    if (bar) document.documentElement.classList.add('has-mbar');
    /* the home bar's rule; the reserve page's own bar (.pdp-bar) is driven only by initMobileBar below (30 Sep) */
    if (bar && !bar.classList.contains('pdp-bar')) bar.classList.toggle('show', y > window.innerHeight * .9);
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  /* reveal on scroll */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -10% 0px'});
  var initReveal = safe(function(root){ $$('.rv', root).forEach(function(el){ io.observe(el); }); });

  /* looping clips play only while on screen, and never for reduced motion */
  var vio = new IntersectionObserver(function(es){
    es.forEach(function(e){
      var v = e.target;
      if (v.dataset.manual) return;
      if (e.isIntersecting){ var p = v.play(); if (p && p.catch) p.catch(function(){}); } else v.pause();
    });
  }, {threshold:.25});
  var initVideos = safe(function(root){ if (!reduce) $$('video[data-auto]', root).forEach(function(v){ vio.observe(v); }); });

  /* film: the first tap always turns the sound on and starts the film from the top.
     Part 2: the big play badge shrinks to a corner pause button while the film plays with sound (class
     is-playing on [data-film]); a tap anywhere on the picture plays or pauses too. When the film ends it goes back to the silent
     preview loop. Older markup (a small button holding one icon) still gets its icon swapped. */
  var initFilm = safe(function(root){
    $$('.film-play', root).forEach(function(b){
      if (b.__lumiFilm) return; b.__lumiFilm = 1;
      var frame = b.closest('.film-frame') || b.parentNode;
      var v = frame.querySelector('video'); if (!v) return;
      var box = b.closest('[data-film]'), fresh = true, iconSwap = !b.querySelector('.fp-disc');
      function show(playing){
        if (box){ box.classList.toggle('is-playing', playing); if (playing) box.classList.remove('is-ended'); }
        b.setAttribute('aria-label', playing ? 'Pause the film' : 'Play the film with sound');
        b.setAttribute('aria-pressed', playing ? 'true' : 'false');
        if (iconSwap) b.innerHTML = playing ? PAUSE : PLAY;
      }
      function toggle(){
        v.dataset.manual = '1';
        if (v.paused || v.muted){
          if (fresh){ fresh = false; try { v.currentTime = 0; } catch(e){} }
          v.muted = false; v.loop = false;
          var p = v.play(); if (p && p.catch) p.catch(function(){});
          show(true);
        } else { v.pause(); show(false); }
      }
      b.addEventListener('click', function(e){ e.stopPropagation(); toggle(); });
      frame.addEventListener('click', function(){ if (box) toggle(); });
      v.addEventListener('ended', function(){
        fresh = true; v.muted = true; v.loop = true; delete v.dataset.manual;
        show(false); if (box) box.classList.add('is-ended');
        if (!reduce){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      });
    });
  });

  /* hero: see hero.js (Lumi runs a session on its own screen) */

  /* how it works: the step in the middle of the screen drives the sticky video */
  var initHow = safe(function(root){
    /* one media item per step, in order: a clip (video) or a still (.how-shot, e.g. a flat app screenshot card) */
    var steps = $$('.step', root), vids = $$('.how-screen > video, .how-screen > .how-shot', root);
    if (!steps.length || !vids.length) return;
    var sio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        var i = steps.indexOf(e.target);
        steps.forEach(function(s,j){ s.classList.toggle('on', j === i); });
        /* the studio Lumi beside the app screens follows the step: ring on the tap, countdown, then the happy face */
        var hl = $('[data-how-lumi]', root), hlcd = hl && $('.lcd', hl);
        if (hl){ hl.setAttribute('data-step', i); var fc = i === steps.length - 2 ? 'focus' : i === steps.length - 1 ? 'done' : ''; if (hlcd){ if (fc) hlcd.setAttribute('data-face', fc); hlcd.classList.toggle('show', !!fc); } }
        vids.forEach(function(v,j){
          var on = j === i; v.classList.toggle('on', on);
          if (!v.play) return;
          /* on phones the desktop media column is hidden and each step has its own clip, so never load these */
          if (!v.offsetParent){ v.pause(); return; }
          if (on && !reduce){ v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function(){}); } else v.pause();
        });
      });
    }, {rootMargin:'-45% 0px -45% 0px'});
    steps.forEach(function(s){ sio.observe(s); });
  });

  /* radio-style option groups: one tab stop, arrow keys move and select */
  function radioKeys(group, itemSel){
    var items = $$(itemSel, group);
    function sync(){ items.forEach(function(o){ o.setAttribute('tabindex', o.classList.contains('on') ? '0' : '-1'); }); }
    sync();
    group.addEventListener('keydown', function(e){
      var k = e.key, i = items.indexOf(document.activeElement);
      if (i < 0 || ['ArrowRight','ArrowDown','ArrowLeft','ArrowUp'].indexOf(k) < 0) return;
      e.preventDefault();
      var n = (k === 'ArrowRight' || k === 'ArrowDown') ? (i + 1) % items.length : (i - 1 + items.length) % items.length;
      items[n].click(); items[n].focus();
    });
    group.addEventListener('click', function(){ setTimeout(sync, 0); });
  }

  /* colour pickers (home stage and reserve gallery share the pattern) */
  /* 17 Oct 2026 (speed): on the reserve page the colours not shown yet wait in data-src; a tapped colour loads at once,
     the rest (and the mini-Lumi swatch pictures, .frC-row[data-fed]) after the page's load event */
  function feedImg(im){ var s = im.getAttribute('data-src'); if (s){ im.setAttribute('src', s); im.removeAttribute('data-src'); } }
  function afterLoad(fn){ var go = function(){ setTimeout(fn, 200); }; if (document.readyState === 'complete') go(); else window.addEventListener('load', go); }
  var initColours = safe(function(root){
    $$('[data-colours]', root).forEach(function(group){
      var scope = group.closest('[data-colour-scope]') || document;
      var imgs = $$('[data-colour-img]', scope);
      afterLoad(function(){ imgs.forEach(feedImg); var row = group.closest('.frC-row'); if (row) row.setAttribute('data-fed', ''); });
      var opt = group.closest('.opt');
      var name = (opt && $('.sw-name', opt)) || $('.sw-name', scope);
      $$('.sw', group).forEach(function(sw){
        sw.addEventListener('click', function(){
          $$('.sw', group).forEach(function(o){ o.classList.toggle('on', o === sw); o.setAttribute('aria-checked', o === sw); });
          imgs.forEach(function(im){ var on = im.dataset.colourImg === sw.dataset.colour; if (on) feedImg(im); im.classList.toggle('on', on); });
          if (name) name.textContent = sw.dataset.label;
          var form = group.closest('form') || scope;
          var hidden = $('[name="colour"]', form) || $('[name="properties[Colour]"]', form);
          if (hidden) hidden.value = sw.dataset.value || sw.dataset.label;
          buzz(8);
          /* part 2: the home colour section floods and Lumi reacts (middle.js listens for this) */
          try { group.dispatchEvent(new CustomEvent('lumi:colour', {bubbles:true, detail:{swatch:sw}})); } catch(e){}
        });
      });
      radioKeys(group, '.sw');
    });
  });

  /* option cards (batch) */
  var initCards = safe(function(root){
    $$('[data-cards]', root).forEach(function(group){
      var opt = group.closest('.opt');
      $$('.card-opt', group).forEach(function(c){
        c.addEventListener('click', function(){
          $$('.card-opt', group).forEach(function(o){ o.classList.toggle('on', o === c); o.setAttribute('aria-checked', o === c); });
          var lbl = (opt && $('[data-batch-label]', opt)) || $('[data-batch-label]');
          if (lbl) lbl.textContent = c.dataset.label;
          var kick = c.dataset.kicker && $('[data-batch-kicker]'); if (kick) kick.textContent = c.dataset.kicker;
          var hidden = $('[name="batch"]'); if (hidden) hidden.value = c.dataset.label;
          buzz(8);
        });
      });
      radioKeys(group, '.card-opt');
    });
  });

  /* roadmap: fill the line up to "now" once the line itself is well on screen, drag to scroll.
     "Well on screen" means the line has cleared the phone reserve bar (or the bottom edge) with a little room to spare,
     so the fill and the little Lumi riding it (collections.js listens for lumi:rm-go) are seen moving, never finished off screen. */
  var initRoadmap = safe(function(root){
    var track = $('.rm-track', root); if (!track || track.__lumiRoad) return;
    track.__lumiRoad = 1;
    var fill = $('.rm-fill', track), line = $('.rm-line', track), now = $('.ms.now', track);
    function inView(){
      var r = line.getBoundingClientRect(), vh = window.innerHeight, bottom = vh, bar = $('.mbar');
      if (!r.width && !r.height) return false;
      if (bar && getComputedStyle(bar).display !== 'none'){ var br = bar.getBoundingClientRect(); if (br.top < vh) bottom = br.top - 8; }
      return r.top < bottom - vh * .06;
    }
    var gone = false, rq = 0;
    function go(){
      if (gone || !now || !fill) return; gone = true;
      window.removeEventListener('scroll', check); window.removeEventListener('resize', check);
      var lr = line.getBoundingClientRect(), nr = now.getBoundingClientRect();
      fill.style.width = Math.max(0, nr.left - lr.left + 8) + 'px';
      track.classList.add('rm-go');
      var ev; try { ev = new CustomEvent('lumi:rm-go'); } catch(e){ ev = document.createEvent('Event'); ev.initEvent('lumi:rm-go', false, false); }
      track.dispatchEvent(ev);
    }
    function check(){ if (rq) return; rq = requestAnimationFrame(function(){ rq = 0; if (inView()) go(); }); }
    window.addEventListener('scroll', check, {passive:true}); window.addEventListener('resize', check);
    check();
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; track.classList.add('drag'); });
    window.addEventListener('pointermove', function(e){ if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 3) moved = true; track.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function(){ down = false; track.classList.remove('drag'); });
    track.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); } }, true);
  });

  var ALL = [initReveal, initVideos, initFilm, initHow, initColours, initCards, initRoadmap];
  window.LumiInit = window.LumiInit || [];
  ALL.forEach(function(fn){ window.LumiInit.push(fn); fn(document); });

  /* Shopify theme editor: re-run everything inside a section it has just re-rendered */
  if (!window.__lumiSectionHook){
    window.__lumiSectionHook = true;
    document.addEventListener('shopify:section:load', function(e){
      (window.LumiInit || []).forEach(function(fn){ fn(e.target); });
    });
  }
})();

/* Shopify reserve page: map the chosen batch (and colour, when it is a real option) to a variant, then checkout. */
(function(){
  var root = document.querySelector('[data-product]');
  if (!root) return;
  var json = root.querySelector('[data-variants]');
  if (!json) return;
  var variants = [];
  try { variants = JSON.parse(json.textContent); } catch(e){ return; }
  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var buy = root.querySelector('[data-buy]');
  var buyLabel = buy ? (buy.getAttribute('data-cta') || buy.textContent.trim()) : '';
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
  var cur = root.getAttribute('data-currency') || 'GBP', loc = root.getAttribute('data-locale') || 'en-GB';
  var shownPrice = priceEl ? +(priceEl.getAttribute('data-cents') || -1) : -1;
  function money(cents){
    try { return new Intl.NumberFormat(loc, {style:'currency', currency:cur, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2}).format(cents / 100); }
    catch(e){ return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function update(){
    var picked = groups.map(function(g){ var on = g.querySelector('.on'); return on ? on.getAttribute('data-value') : null; });
    var match = variants.filter(function(v){ return picked.every(function(val, i){ return v.options[i] === val; }); })[0];
    if (!match){ if (buy){ buy.disabled = true; buy.textContent = 'Unavailable'; } return; }
    idInput.value = match.id;
    /* only reformat when the amount really changes, so the server-rendered format is kept */
    if (priceEl && match.price !== shownPrice){ priceEl.textContent = money(match.price); shownPrice = match.price; }
    if (buy){ buy.disabled = !match.available; buy.textContent = match.available ? buyLabel : 'Sold out'; }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    url.searchParams.delete('batch');
    window.history.replaceState({}, '', url.toString());
  }
  groups.forEach(function(g){ g.addEventListener('click', function(e){ if (e.target.closest('button')) setTimeout(update, 0); }); });
})();

/* v2.3 hero: Lumi runs a focus session on its own screen.
   Plays once by itself when Lumi is properly on screen, then the ring or the button replays it. */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s,r){return (r||document).querySelector(s)};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var buzz = function(ms){ if (!navigator.vibrate) return; if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return; try{navigator.vibrate(ms)}catch(e){} };

  function initDemo(root){
    var stage = $('.hero-stage[data-demo]', root || document);
    if (!stage || stage.getAttribute('data-lumi-demo')) return;
    stage.setAttribute('data-lumi-demo', '1');
    var hero = stage.closest('section') || document;
    var halo = $('.halo', stage), rig = $('.lumi-rig', stage), lcd = $('.lcd', stage), clock = $('[data-clock]', stage), rp = $('.ringfx .rp', stage);
    var hit = $('.ring-hit', stage), btn = $('[data-demo-btn]', hero), label = $('[data-demo-label]', hero);
    var status = $('[data-session-status]', hero), steps = $$('.steps li', hero);
    var tLock = $('.t-lock', stage), tNotice = $('.t-notice', stage), tDone = $('.t-done', stage);
    var idleLabel = label ? label.textContent : 'Watch a session';
    var hovering = false, running = false, raf = 0, timers = [], blinkT = 0, autoplayed = false, userRan = false, quiet = true, startedAt = 0;
    var DUR = 8200, TOTAL = 25 * 60;

    function later(fn, ms){ var t = setTimeout(fn, ms); timers.push(t); return t; }
    function face(f){ if (!lcd) return; if (f) lcd.setAttribute('data-face', f); lcd.classList.toggle('show', !!f); }
    function toast(el, on){ if (el) el.classList.toggle('on', !!on); }
    /* only a visitor's own tap is narrated to screen readers or buzzes the phone, never the autoplay */
    function say(t){ if (status && !quiet) status.textContent = t; }
    function hz(ms){ if (!quiet) buzz(ms); }
    function step(name){
      var hitIdx = -1;
      steps.forEach(function(li, i){ if (li.getAttribute('data-step') === name) hitIdx = i; });
      steps.forEach(function(li, i){ li.classList.toggle('on', i === hitIdx); li.classList.toggle('did', hitIdx > -1 && i < hitIdx); });
    }
    function setClock(s){ if (clock) clock.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0'); }
    function setRing(p){ if (rp) rp.style.strokeDashoffset = (100 * (1 - p)).toFixed(2); }

    function reset(){
      timers.forEach(clearTimeout); timers = []; cancelAnimationFrame(raf); raf = 0;
      stage.classList.remove('run', 'alert', 'kept', 'tapped');
      face(null); toast(tLock); toast(tNotice); toast(tDone); setRing(0); step(null);
      if (label) label.textContent = idleLabel;
      running = false; blink();
    }
    function finish(){
      step('kept'); face('done'); stage.classList.remove('alert'); stage.classList.add('kept'); setRing(1);
      toast(tNotice); toast(tDone, true); hz([12, 60, 12]); say('Session kept. Plus 25 XP.');
      later(reset, 3400);
    }
    function notice(){
      stage.classList.add('alert'); face('notice'); toast(tNotice, true); hz(8);
      say('Instagram tried to open. Lumi noticed.');
      later(function(){
        if (!running || stage.classList.contains('kept')) return;
        stage.classList.remove('alert'); face('focus'); toast(tNotice);
      }, 1600);
    }
    function countdown(){
      if (reduce){
        later(function(){ setClock(870); setRing(.42); notice(); }, 1200);
        later(function(){ setClock(0); finish(); }, 3400);
        return;
      }
      var start = 0, noticed = false;
      function frame(t){
        if (!start) start = t;
        var p = Math.min(1, (t - start) / DUR);
        setClock(Math.round(TOTAL * (1 - p))); setRing(p);
        if (!noticed && p > 0.42 && p < 0.9){ noticed = true; notice(); }
        if (p < 1) raf = requestAnimationFrame(frame); else { raf = 0; finish(); }
      }
      raf = requestAnimationFrame(frame);
    }
    function run(e){
      if (running){ reset(); return; }
      quiet = !e; if (e) userRan = true;
      running = true; startedAt = Date.now(); clearTimeout(blinkT);
      if (label) label.textContent = 'Stop the demo';
      hz(18);
      stage.classList.add('tapped', 'run'); later(function(){ stage.classList.remove('tapped'); }, 750);
      step('tap'); setClock(TOTAL); setRing(0); face('focus'); toast(tLock, true);
      say('Phone tapped. Distracting apps locked for 25 minutes.');
      later(function(){ toast(tLock); step('focus'); countdown(); }, 1500);
    }
    /* idle: Lumi blinks now and then */
    function blink(){
      clearTimeout(blinkT);
      if (reduce) return;
      blinkT = setTimeout(function(){
        if (running || hovering) return;
        var twice = Math.random() < .3;
        face('blink');
        blinkT = setTimeout(function(){
          if (running || hovering) return;
          face(null);
          if (!twice) return blink();
          blinkT = setTimeout(function(){
            if (running || hovering) return;
            face('blink');
            blinkT = setTimeout(function(){ if (!running && !hovering) face(null); blink(); }, 160);
          }, 150);
        }, 180);
      }, 1800 + Math.random() * 2600);
    }

    /* the ring always (re)starts a session, it never stops one; a double tap does nothing extra */
    if (hit) hit.addEventListener('click', function(e){
      if (running && Date.now() - startedAt < 600) return;
      if (running){ reset(); void stage.offsetWidth; }
      run(e);
    });
    /* the button is a play and stop toggle */
    if (btn) btn.addEventListener('click', function(e){ run(e); });
    /* idle Lumi notices a mouse pointer and looks up, then goes back to blinking */
    if (rig && !reduce){
      rig.addEventListener('pointerenter', function(e){ if (e.pointerType !== 'mouse') return; hovering = true; if (running) return; clearTimeout(blinkT); face('notice'); });
      rig.addEventListener('pointerleave', function(e){ if (e.pointerType !== 'mouse') return; hovering = false; if (running) return; face(null); blink(); });
    }
    blink();

    /* play once by itself when Lumi is properly on screen (or fills half the viewport on short screens) */
    if (!reduce && 'IntersectionObserver' in window){
      /* on phones only Lumi's head peeks onto the first screen; the demo starts once the ring is in view too */
      var need = window.matchMedia('(max-width:560px)').matches ? .8 : .55;
      new IntersectionObserver(function(es, o){
        var en = es[es.length - 1];
        if (autoplayed || !en.isIntersecting) return;
        if (en.intersectionRatio < need && en.intersectionRect.height < window.innerHeight * .5) return;
        autoplayed = true; o.disconnect();
        later(function(){
          var r = stage.getBoundingClientRect();
          if (!running && !userRan && r.bottom > 0 && r.top < window.innerHeight) run();
        }, 1500);
      }, {threshold:[0, .15, .3, .45, .55, .65, .8, .9]}).observe(stage);
    }

    /* the whole rig lifts gently as the page scrolls: 0 at the top, so nothing jumps on the first scroll */
    if (!reduce && rig){
      var lift = function(){
        var r = stage.getBoundingClientRect(), y = window.scrollY || window.pageYOffset || 0;
        var p = Math.min(1, Math.max(0, y / Math.max(1, r.bottom + y)));
        rig.style.transform = p ? 'translateY(' + (-p * 40).toFixed(1) + 'px) scale(' + (1 - p * .06).toFixed(4) + ')' : '';
        /* the ground shadow follows Lumi's feet up */
        if (halo) halo.style.translate = p ? '0 ' + (-p * (40 + r.height * .02)).toFixed(1) + 'px' : '';
      };
      window.addEventListener('scroll', lift, {passive:true});
      window.addEventListener('resize', lift);
      lift();
    }
  }

  window.LumiInit = window.LumiInit || [];
  window.LumiInit.push(function(r){ try { initDemo(r); } catch(e){ if (window.console) console.warn('lumi:', e); } });
  initDemo(document);
})();

/* v2.2 features: scroll-assembled inside view, October beta wall, concept gallery, batch preselect. */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s,r){return (r||document).querySelector(s)};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var buzz = function(ms){ if (!navigator.vibrate) return; if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return; try{navigator.vibrate(ms)}catch(e){} };
  var clamp = function(x,a,b){ return Math.min(b, Math.max(a, x)); };
  var safe = function(fn){ return function(root){ try { fn(root || document); } catch(e){ if (window.console) console.warn('lumi:', e); } }; };
  var mark = function(el, k){ if (el.getAttribute('data-lumi-' + k)) return false; el.setAttribute('data-lumi-' + k, '1'); return true; };

  /* INSIDE: map scroll through the tall track to the clip's time, eased so it glides.
     The clip (3.3 MB, every frame a keyframe) only starts loading as the section comes near. */
  var initScrub = safe(function(root){
    $$('[data-scrub]', root).forEach(function(sec){
      if (!mark(sec, 'scrub')) return;
      var track = $('.scrub-track', sec), v = $('video', sec), bar = $('.scrub-bar i', sec), parts = $$('.parts li', sec);
      if (!track || !v) return;
      if (reduce){ sec.classList.add('static'); parts.forEach(function(li){ li.classList.add('lit'); }); return; }
      /* part 3: the clip finishes at HOLD (60%) of the way down the track; the rest of the scroll holds the built Lumi
         still so Lumi's screen can wake up (collections.js listens for lumi:scrub) */
      var HOLD = 0.6;
      var dur = 0, target = 0, cur = 0, raf = 0, visible = false, loaded = false, lastVp = -1;
      function ready(){ dur = v.duration || 0; update(); }
      v.addEventListener('loadedmetadata', ready);
      if (v.readyState >= 1) ready();
      function progress(){
        var r = track.getBoundingClientRect(), total = track.offsetHeight - window.innerHeight;
        return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
      }
      function paint(p){
        var vp = clamp(p / HOLD, 0, 1), last = 0;
        if (bar) bar.style.transform = 'scaleX(' + vp.toFixed(4) + ')';
        parts.forEach(function(li, i){ var on = vp >= (i + 1) / (parts.length + 1); li.classList.toggle('lit', on); if (on) last = i; });
        /* phones show one caption at a time: the part that lit up last */
        parts.forEach(function(li, i){ li.classList.toggle('cur', i === last); });
        sec.classList.toggle('built', vp >= 1);
        if (vp !== lastVp){ lastVp = vp; try { sec.dispatchEvent(new CustomEvent('lumi:scrub', {detail:{p:p, vp:vp}})); } catch(e){} }
        return vp;
      }
      function tick(){
        raf = 0;
        var diff = target - cur;
        cur = Math.abs(diff) < 0.004 ? target : cur + diff * 0.16;
        if (dur && Math.abs(v.currentTime - cur) > 0.001){ try { v.currentTime = cur; } catch(e){} }
        if (cur !== target) raf = requestAnimationFrame(tick);
      }
      function update(){
        if (!visible) return;
        var vp = paint(progress());
        if (!dur) return;
        target = vp * Math.max(0, dur - 0.05);
        if (!raf) raf = requestAnimationFrame(tick);
      }
      /* iOS only paints seeks once the video has been played at least once */
      function unlock(){ var p = v.play(); if (p && p.then) p.then(function(){ v.pause(); update(); }).catch(function(){}); }
      function load(){
        if (loaded) return; loaded = true;
        /* phones get the 960 x 540 cut (1.6 MB instead of 3.2 MB); it scrubs the same */
        if (v.dataset.srcSm && window.matchMedia('(max-width: 760px)').matches) v.src = v.dataset.srcSm;
        v.preload = 'auto'; v.load();
        window.addEventListener('touchstart', unlock, {passive:true, once:true});
      }
      new IntersectionObserver(function(es, o){ if (es[0].isIntersecting){ load(); o.disconnect(); } }, {rootMargin:'150% 0px'}).observe(track);
      new IntersectionObserver(function(es){
        visible = es[0].isIntersecting;
        document.documentElement.classList.toggle('scrub-on', visible);
        if (visible) update();
      }, {rootMargin:'0px'}).observe(track);
      window.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
    });
  });

  /* OCTOBER BETA: 100 different Lumis pop in from the centre outwards while the counter runs to 100 */
  var initBeta = safe(function(root){
    $$('[data-beta]', root).forEach(function(sec){
      var wall = $('.beta-wall', sec), num = $('[data-count-to]', sec);
      if (!wall || !mark(wall, 'beta')) return;
      var srcs = (wall.getAttribute('data-srcs') || '').split(',').filter(Boolean);
      var n = +(wall.getAttribute('data-n') || 100);
      if (srcs.length) n = Math.min(n, srcs.length); /* each Lumi appears once, never repeated */
      var cols = 10, rows = Math.ceil(n / cols), frag = document.createDocumentFragment();
      /* part 3: every tile is a button (tapping one says hi, see collections.js), one tab stop for the wall */
      for (var i = 0; i < n; i++){
        var t = document.createElement('button'), row = Math.floor(i / cols), col = i % cols;
        var num = srcs[i] && (srcs[i].match(/w-0*([0-9]+)/) || [])[1];
        t.type = 'button'; t.className = 'bt'; t.tabIndex = i ? -1 : 0;
        t.setAttribute('data-k', i); if (num) t.setAttribute('data-no', num);
        t.setAttribute('aria-label', 'Concept Lumi' + (num ? ' number ' + num : ''));
        var dist = Math.hypot(row - (rows - 1) / 2, col - (cols - 1) / 2);
        t.style.setProperty('--d', (dist * 0.07).toFixed(2) + 's');
        frag.appendChild(t);
      }
      wall.appendChild(frag);
      if (srcs.length) new IntersectionObserver(function(es, o){
        if (!es[0].isIntersecting) return; o.disconnect();
        $$('.bt', wall).forEach(function(t, k){ t.style.backgroundImage = 'url("' + srcs[k] + '")'; });
      }, {rootMargin:'100% 0px'}).observe(wall);
      function count(){
        if (!num) return;
        var to = +num.getAttribute('data-count-to'), start = null, D = reduce ? 1 : 1600;
        function step(ts){ if (!start) start = ts; var k = clamp((ts - start) / D, 0, 1), e = 1 - Math.pow(1 - k, 3);
          num.textContent = Math.round(e * to); if (k < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      }
      new IntersectionObserver(function(es, o){
        if (!es[0].isIntersecting) return;
        wall.classList.add('go'); o.disconnect();
      }, {threshold:.3}).observe(wall);
      if (num) new IntersectionObserver(function(es, o){ if (!es[0].isIntersecting) return; o.disconnect(); count(); }, {threshold:.75}).observe(num);
    });
  });

  /* CONCEPTS: filter chips, hearts, and a mailto with the visitor's picks */
  var initConcepts = safe(function(root){
    $$('[data-concepts]', root).forEach(function(sec){
      if (!mark(sec, 'concepts')) return;
      var tiles = $$('.ct', sec), chips = $$('.chip', sec), picksBar = $('.picks', sec);
      var countEl = picksBar && $('[data-picks-count]', picksBar), send = picksBar && $('[data-picks-send]', picksBar);
      var to = sec.getAttribute('data-email') || 'hello@get-lumi.com', KEY = 'lumi-concept-picks', picks = [];
      try { picks = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ picks = []; }
      if (!Array.isArray(picks)) picks = [];
      var names = tiles.map(function(t){ return t.getAttribute('data-name'); });
      picks = picks.filter(function(p){ return names.indexOf(p) > -1; });
      function save(){ try { localStorage.setItem(KEY, JSON.stringify(picks)); } catch(e){} }
      chips.forEach(function(c){
        c.addEventListener('click', function(){
          var cat = c.getAttribute('data-cat');
          chips.forEach(function(o){ o.classList.toggle('on', o === c); o.setAttribute('aria-pressed', o === c); });
          tiles.forEach(function(t){
            var show = cat === 'all' || t.getAttribute('data-cat') === cat;
            var was = !t.classList.contains('hide');
            t.classList.toggle('hide', !show);
            if (show && !was){ t.classList.remove('pop'); void t.offsetWidth; t.classList.add('pop'); }
          });
          buzz(6);
        });
      });
      function render(){
        tiles.forEach(function(t){ var h = $('.heart', t); if (h) h.setAttribute('aria-pressed', picks.indexOf(t.getAttribute('data-name')) > -1); });
        if (!picksBar) return;
        picksBar.classList.toggle('show', picks.length > 0);
        if (countEl) countEl.textContent = picks.length === 1 ? '1 favourite picked' : picks.length + ' favourites picked';
        if (send) send.href = 'mailto:' + to + '?subject=' + encodeURIComponent('My favourite Lumi concepts') +
          '&body=' + encodeURIComponent('The ones I would carry:\n\n' + picks.map(function(p){ return '- ' + p; }).join('\n') + '\n');
      }
      tiles.forEach(function(t){
        var h = $('.heart', t); if (!h) return;
        h.addEventListener('click', function(){
          var name = t.getAttribute('data-name'), i = picks.indexOf(name);
          if (i > -1) picks.splice(i, 1); else picks.push(name);
          save(); render(); buzz(10);
        });
      });
      render();
    });
  });

  window.LumiInit = window.LumiInit || [];
  [initScrub, initBeta, initConcepts].forEach(function(fn){ window.LumiInit.push(fn); fn(document); });

  /* Reserve page: ?batch=beta preselects the October beta card, unless a variant is already chosen */
  setTimeout(function(){
    var qs = new URLSearchParams(location.search);
    if (qs.has('variant')) return;
    var want = (qs.get('batch') || '').toLowerCase();
    if (!want) return;
    var card = $$('.card-opt').filter(function(c){ return (c.getAttribute('data-value') || c.getAttribute('data-label') || '').toLowerCase().indexOf(want) > -1; })[0];
    if (card && !card.classList.contains('on')) card.click();
  }, 0);

  if (!window.__lumiSectionHook){
    window.__lumiSectionHook = true;
    document.addEventListener('shopify:section:load', function(e){
      (window.LumiInit || []).forEach(function(fn){ fn(e.target); });
    });
  }
})();

/* Lumi playful layer: the ticker band and off-screen pausing. No libraries.
   Each init runs inside a root element so Shopify's theme editor can re-run it for a re-rendered section. */
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var safe = function(fn){ return function(root){ try { fn(root || document); } catch(e){ if (window.console) console.warn('lumi:', e); } }; };

  /* anything marked data-alive pauses its idle animation while it is off screen */
  var aio = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ e.target.classList.toggle('is-paused', !e.isIntersecting); });
  }, {rootMargin:'60px 0px'}) : null;
  var initAlive = safe(function(root){
    if (!aio) return;
    $$('[data-alive]', root).forEach(function(el){ if (el.__lumiAlive) return; el.__lumiAlive = 1; aio.observe(el); });
  });

  /* ticker: four identical groups slide left by one group, so the band never shows a gap.
     Each group is kept at least a third of the screen wide, and the speed is about 30px a second. */
  var initTicker = safe(function(root){
    $$('[data-ticker]', root).forEach(function(t){
      if (t.__lumiTicker) return; t.__lumiTicker = 1;
      var track = t.querySelector('.tk-track'), groups = $$('.tk-group', t);
      if (!track || !groups.length) return;
      function fit(){
        var w = groups[0].getBoundingClientRect().width, guard = 0;
        var items = $$('li', groups[0]);
        while (w && w * 3 < window.innerWidth && items.length && guard++ < 6){
          groups.forEach(function(g){ items.forEach(function(li){ g.appendChild(li.cloneNode(true)); }); });
          w = groups[0].getBoundingClientRect().width;
        }
        if (w) track.style.setProperty('--tk-dur', (w / 30).toFixed(1) + 's');
      }
      fit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      var rt = 0; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(fit, 200); });
    });
  });

  /* Blend (27 Sep, Petr): every colour block fades into its neighbours instead of meeting them at a hard line.
     Each boundary gets the halfway colour; both sides fade to it, so the seam disappears. Recomputed when a
     block changes colour (the colours section floods to the picked colour) and on resize. */
  function initBlend(){
    function col(el){
      var m = (getComputedStyle(el).backgroundColor || '').match(/[\d.]+/g);
      if (!m || (m.length > 3 && +m[3] === 0)) return null;
      return [+m[0], +m[1], +m[2]];
    }
    function mid(a, b){ return 'rgb(' + Math.round((a[0] + b[0]) / 2) + ',' + Math.round((a[1] + b[1]) / 2) + ',' + Math.round((a[2] + b[2]) / 2) + ')'; }
    function run(){
      var els = [].slice.call(document.querySelectorAll('.blk, .ticker')).filter(function(el){ return !el.parentElement.closest('.blk'); });
      var cs = els.map(col);
      els.forEach(function(el, i){
        if (!el.classList.contains('blk') || !cs[i]) return;
        var own = 'rgb(' + cs[i].join(',') + ')';
        var top = i > 0 && cs[i - 1] ? mid(cs[i - 1], cs[i]) : own;
        var bot = i < els.length - 1 && cs[i + 1] ? mid(cs[i], cs[i + 1]) : own;
        /* only write on a real change, so the MutationObserver below never loops on its own writes */
        if (el.style.getPropertyValue('--mix-top') !== top) el.style.setProperty('--mix-top', top);
        if (el.style.getPropertyValue('--mix-bot') !== bot) el.style.setProperty('--mix-bot', bot);
        if (!el.classList.contains('blended')) el.classList.add('blended');
      });
    }
    run();
    var t = 0, again = function(){ clearTimeout(t); t = setTimeout(run, 60); };
    if ('MutationObserver' in window){
      var mo = new MutationObserver(again);
      [].slice.call(document.querySelectorAll('.blk')).forEach(function(el){ mo.observe(el, {attributes:true, attributeFilter:['class', 'style', 'data-colour']}); });
    }
    window.addEventListener('resize', again);
  }

  /* Cookie banner (30 Sep). Shopify's consent banner (#shopify-pc__banner, z-index 2,000,000) is fixed to the bottom
     of the screen and used to hide the phone reserve bar. Its visible height goes into --pc-h on <html> (0px once it is
     answered, hidden or gone) and lumi.css lifts the bar 8px above it, so the bar never covers Accept, Decline, Manage
     preferences or the privacy link. The "on screen" checks below leave out the strip the banner covers.
     This only reads the banner: its wording, buttons and settings stay Shopify's. */
  var pcH = 0, pcFns = [];
  (function(){
    var de = document.documentElement;
    if (de.__lumiPc) return; de.__lumiPc = 1;
    var seen = null, rq = 0;
    function queue(){ if (!rq) rq = requestAnimationFrame(measure); }
    var ro = "ResizeObserver" in window ? new ResizeObserver(queue) : null;
    var mo = "MutationObserver" in window ? new MutationObserver(queue) : null;
    function measure(){
      rq = 0;
      var b = document.getElementById("shopify-pc__banner"), h = 0;
      if (b !== seen){
        if (seen && ro) ro.unobserve(seen);
        seen = b;
        if (b){ if (ro) ro.observe(b); if (mo) mo.observe(b, {attributes:true, attributeFilter:["style", "class", "hidden"]}); }
      }
      if (b && b.isConnected){
        var cs = getComputedStyle(b), vh = window.innerHeight;
        if (cs.display !== "none" && cs.visibility !== "hidden" && parseFloat(cs.opacity) > .05){
          var r = b.getBoundingClientRect();
          if (r.height > 0 && r.top < vh && r.bottom > 0) h = Math.round(vh - Math.max(0, r.top));
        }
      }
      if (h === pcH) return;
      pcH = h;
      de.style.setProperty("--pc-h", h + "px");
      pcFns.forEach(function(fn){ try { fn(); } catch(e){} });
    }
    try {
      if (mo && document.body) mo.observe(document.body, {childList:true});
      window.addEventListener("resize", queue);
      measure();
    } catch(e){ if (window.console) console.warn("lumi:", e); }
  })();

  /* IntersectionObserver on el over the part of the screen the cookie banner leaves free; rebuilt when --pc-h changes */
  function watchFree(el, threshold, fn){
    if (!("IntersectionObserver" in window)) return;
    var w = el.__lumiFree;
    if (!w){
      w = el.__lumiFree = {io:null};
      w.build = function(){
        if (w.io) w.io.disconnect();
        w.io = new IntersectionObserver(function(es){ w.fn(es[es.length - 1]); }, {threshold:w.threshold, rootMargin:"0px 0px -" + pcH + "px 0px"});
        w.io.observe(el);
      };
      pcFns.push(w.build);
    }
    w.fn = fn; w.threshold = threshold;
    w.build();
  }

  /* Mobile pass (27 Sep). The floating reserve bar steps aside while the reserve band (which has its own button)
     is on screen. On the reserve page, phones get the same floating bar until the real reserve button is in view;
     it presses that button, so the chosen batch and colour go through exactly as normal. */
  function initMobileBar(){
    var band = document.querySelector("section.reserve");
    if (band) watchFree(band, .25, function(e){ document.documentElement.classList.toggle("reserve-on", e.isIntersecting); });
    var buy = document.querySelector(".pdp [data-buy]");
    if (!buy || document.querySelector(".mbar")) return;
    var bar = document.createElement("div");
    bar.className = "mbar pdp-bar";
    bar.innerHTML = '<span class="mbar-txt"><b>Lumi</b></span><button type="button" class="btn btn-glow"></button>';
    var b = bar.querySelector("button");
    function label(){ b.textContent = (buy.textContent || "").trim(); b.disabled = !!buy.disabled; }
    label();
    new MutationObserver(label).observe(buy, {childList:true, characterData:true, subtree:true, attributes:true, attributeFilter:["disabled"]});
    b.addEventListener("click", function(){ buy.click(); });
    document.body.appendChild(bar);
    document.documentElement.classList.add("has-mbar");
    /* one rule (30 Sep): the bar shows whenever the reserve button is not at least half on screen above the cookie
       banner, and hides while it is. Nothing else toggles this bar (see onScroll at the top). */
    watchFree(buy, [0, .5, 1], function(e){ bar.classList.toggle("show", !(e.intersectionRatio >= .5)); });
  }


  /* RESERVE GALLERY (27 Sep): the colour render, then photos. Arrows, counter, thumbnails, swipe and arrow keys.
     Photos load when first shown (and the next one just before). Picking a colour jumps back to the render, unless
     the bag photo is showing, which follows the colour when there is one for it. */
  function initGalleryViews(){
    var g = document.querySelector('.pdp-gallery[data-view]'); if (!g || g.__views) return; g.__views = 1;
    var media = g.closest('.pdp-media') || g.parentNode, strip = media.querySelector('.g-thumbs');
    var thumbs = [].slice.call(media.querySelectorAll('.g-thumb')); if (!thumbs.length) return;
    var order = thumbs.map(function(t){ return t.getAttribute('data-v'); });
    var cap = g.querySelector('[data-g-cap]'), num = g.querySelector('[data-g-n]');
    var tFront = media.querySelector('[data-thumb-front]'), tBag = media.querySelector('[data-thumb-bag]');
    var scope = g.closest('[data-colour-scope]') || document, colour = 'cream', name = 'Cream';
    function bagFor(c){ return g.querySelector('.g-view[data-view="bag"][data-bag="' + c + '"]') || g.querySelector('.g-view[data-view="bag"][data-bag="cream"]') || g.querySelector('.g-view[data-view="bag"]'); }
    function img(v){ return v === 'front' ? null : v === 'bag' ? bagFor(colour) : g.querySelector('.g-view[data-view="' + v + '"]'); }
    function load(im){ if (im && !im.getAttribute('src') && im.getAttribute('data-src')) im.setAttribute('src', im.getAttribute('data-src')); }
    function setColour(sw){
      colour = sw.getAttribute('data-colour'); name = sw.getAttribute('data-label');
      var front = scope.querySelector('[data-colour-img="' + colour + '"]');
      if (tFront && front){ tFront.src = front.getAttribute('src') || front.getAttribute('data-src'); tFront.parentNode.style.background = sw.getAttribute('data-flood') || ''; }
      var bag = bagFor(colour); if (tBag && bag) tBag.src = bag.getAttribute('data-thumb') || bag.getAttribute('data-src') || bag.getAttribute('src');
    }
    function show(v, user){
      var i = order.indexOf(v); if (i < 0){ i = 0; v = order[0]; }
      g.setAttribute('data-view', v);
      var pick = img(v); load(pick); load(img(order[(i + 1) % order.length]));
      [].forEach.call(g.querySelectorAll('.g-view'), function(im){ im.classList.toggle('on', im === pick); });
      thumbs.forEach(function(t, k){ t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      if (num) num.textContent = i + 1;
      if (cap){
        var t = thumbs[i], c = t.getAttribute('data-cap') || '';
        if (v === 'bag') c = c + ' ' + (pick && pick.getAttribute('data-bag') === colour ? name : 'Cream') + '.';
        else if (t.hasAttribute('data-cream') && colour !== 'cream') c += ' ' + t.getAttribute('data-cream');
        cap.textContent = v === 'front' ? '' : c;
      }
      if (user && strip){ var tt = thumbs[i]; try { strip.scrollTo({left: tt.offsetLeft - (strip.clientWidth - tt.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth'}); } catch(e){} }
    }
    function step(d){ var i = order.indexOf(g.getAttribute('data-view')); show(order[(i + d + order.length) % order.length], true); }
    var on = scope.querySelector('[data-colours] .sw.on'); if (on) setColour(on);
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ show(t.getAttribute('data-v'), true); }); });
    var prev = g.querySelector('.g-prev'), next = g.querySelector('.g-next');
    if (prev) prev.addEventListener('click', function(e){ e.stopPropagation(); step(-1); });
    if (next) next.addEventListener('click', function(e){ e.stopPropagation(); step(1); });
    media.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft'){ step(-1); e.preventDefault(); }
      else if (e.key === 'ArrowRight'){ step(1); e.preventDefault(); }
    });
    scope.addEventListener('lumi:colour', function(e){
      var sw = e.detail && e.detail.swatch; if (!sw) return;
      setColour(sw);
      show(g.getAttribute('data-view') === 'bag' ? 'bag' : 'front');
    });
    /* swipe between pictures on phones */
    var x0 = null, y0 = 0;
    g.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, {passive:true});
    g.addEventListener('touchend', function(e){
      if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      step(dx < 0 ? 1 : -1);
    }, {passive:true});
  }

  /* FILM CHAPTERS (27 Sep call, Petr: "press one, two, three, four if you want to skip quickly").
     A chapter button starts the film with sound if it is still on the silent preview, then jumps to that step.
     The button for the step on screen stays lit while the film plays. */
  function initFilmChapters(){
    [].forEach.call(document.querySelectorAll('[data-film-ch]'), function(row){
      if (row.__ch) return; row.__ch = 1;
      var sec = row.closest('section') || document, v = sec.querySelector('[data-film] video'), play = sec.querySelector('.film-play');
      if (!v) return;
      var btns = [].slice.call(row.querySelectorAll('.fch')), end = parseFloat(row.getAttribute('data-end')) || 1e9;
      var ts = btns.map(function(b){ return parseFloat(b.getAttribute('data-t')) || 0; });
      function mark(){
        var t = v.currentTime, on = -1;
        ts.forEach(function(x, i){ if (t >= x - .05 && t < end) on = i; });
        btns.forEach(function(b, i){ b.classList.toggle('on', i === on); b.setAttribute('aria-current', i === on ? 'true' : 'false'); });
      }
      btns.forEach(function(b, i){
        b.addEventListener('click', function(){
          if ((v.paused || v.muted) && play) play.click();
          try { v.currentTime = ts[i]; } catch(e){}
          if (v.paused){ var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); }
          mark();
        });
      });
      v.addEventListener('timeupdate', mark);
      v.addEventListener('seeked', mark);
    });
  }

  var ALL = [initAlive, initTicker, initBlend, initMobileBar, initGalleryViews, initFilmChapters];
  window.LumiInit = window.LumiInit || [];
  ALL.forEach(function(fn){ window.LumiInit.push(fn); fn(document); });
})();

/* Lumi part 2 (25 Sep 2026): the film Lumi, the how-it-works score card, the size comparison and the colour
   flood. No libraries. Every init runs inside a root element
   and marks what it has set up, so Shopify's theme editor can re-run it for a re-rendered section.
   Anything missing on a page (story, reserve) is simply skipped. */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s,r){return (r||document).querySelector(s)};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var within = function(root, sel){ var out = $$(sel, root); if (root.matches && root.matches(sel)) out.unshift(root); return out; };
  var buzz = function(ms){ if (!navigator.vibrate) return; if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return; try{navigator.vibrate(ms)}catch(e){} };
  var safe = function(fn){ return function(root){ try { fn(root || document); } catch(e){ if (window.console) console.warn('lumi:', e); } }; };
  /* restart a one-shot CSS animation class */
  var again = function(el, cls){ if (!el || reduce) return; el.classList.remove(cls); void el.getBoundingClientRect(); el.classList.add(cls); };
  var inView = function(el){ var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight && r.width > 0; };

  /* ---- Lumi blinks now and then, only while on screen ---- */
  var bio = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ e.target.__lumiVis = e.isIntersecting; });
  }) : null;
  function blinkLoop(el){
    el.__lumiBT = setTimeout(function(){
      if (el.__lumiVis !== false && !document.hidden){
        el.setAttribute('data-blink', '');
        setTimeout(function(){
          el.removeAttribute('data-blink');
          if (Math.random() < .25) setTimeout(function(){ el.setAttribute('data-blink', ''); setTimeout(function(){ el.removeAttribute('data-blink'); }, 140); }, 170);
        }, 150);
      }
      blinkLoop(el);
    }, 2200 + Math.random() * 3800);
  }
  var initBlink = safe(function(root){
    if (reduce) return;
    within(root, '[data-lumi-blink]').forEach(function(el){
      if (el.__lumiBlink) return; el.__lumiBlink = 1;
      if (bio) bio.observe(el);
      blinkLoop(el);
    });
  });

  /* ---- FILM: Lumi stands on the frame, watches when the film plays with sound, the ring fills with it ---- */
  var initFilmLumi = safe(function(root){
    within(root, '[data-film]').forEach(function(box){
      if (box.__lumiFilmLumi) return; box.__lumiFilmLumi = 1;
      var v = $('video', box), lumi = $('.film-lumi', box), ring = lumi && $('.lr-p', lumi), btn = $('.film-play', box);
      if (!v || !lumi) return;
      /* round 4: phones get the square cut and its poster (the <source media> picks the file; this covers the
         poster, and browsers that ignore media on <source> and would play the square cut on a wide screen) */
      var sq = window.matchMedia('(max-width: 560px)').matches;
      if (sq && v.dataset.posterSq) v.poster = v.dataset.posterSq;
      function fixSrc(){
        if (sq || !/film-sq\.mp4/.test(v.currentSrc || '')) return;
        var wide = $('source:not([media])', v); if (wide){ v.src = wide.src; v.load(); }
      }
      v.addEventListener('loadstart', fixSrc); fixSrc();
      var hover = false, done = false, doneT = 0;
      function face(){ lumi.setAttribute('data-face', done ? 'done' : (!v.paused && !v.muted) ? 'watch' : hover ? 'ready' : 'idle'); }
      function prog(){ if (ring && v.duration) ring.style.strokeDashoffset = (100 - 100 * Math.min(1, v.currentTime / v.duration)).toFixed(2); }
      v.addEventListener('timeupdate', prog);
      v.addEventListener('loadedmetadata', prog);
      ['play', 'pause', 'volumechange'].forEach(function(ev){ v.addEventListener(ev, face); });
      v.addEventListener('ended', function(){ done = true; face(); clearTimeout(doneT); doneT = setTimeout(function(){ done = false; face(); }, 3600); });
      if (btn){
        btn.addEventListener('pointerenter', function(e){ if (e.pointerType === 'mouse'){ hover = true; face(); } });
        btn.addEventListener('pointerleave', function(){ hover = false; face(); });
        btn.addEventListener('focus', function(){ hover = true; face(); });
        btn.addEventListener('blur', function(){ hover = false; face(); });
      }
      face();
    });
  });

  /* ---- HOW IT WORKS: the score card ticks as you scroll. Minutes count up through step 2 (focus), the XP only
     lands in step 3, after the session, as the copy says ("After, never during"). ---- */
  var COLS = ['#F5A623', '#8E7CF3', '#4C9BE8', '#E86B78', '#4CB878', '#FFFDF9'];
  function confetti(hud){
    if (reduce || !hud) return;
    for (var i = 0; i < 16; i++){
      var c = document.createElement('i'), a = (i / 16) * Math.PI * 2 + Math.random() * .4, d = 70 + Math.random() * 70;
      c.className = 'hud-conf';
      c.style.setProperty('--c', COLS[i % COLS.length]);
      c.style.setProperty('--dx', Math.round(Math.cos(a) * d) + 'px');
      c.style.setProperty('--dy', Math.round(Math.sin(a) * d - 30) + 'px');
      c.style.setProperty('--r', Math.round(Math.random() * 540 - 270) + 'deg');
      hud.appendChild(c);
      setTimeout(function(el){ return function(){ if (el.parentNode) el.parentNode.removeChild(el); }; }(c), 1200);
    }
  }
  /* the XP a completed 25 minute session earns in the iOS app (LumiKit XPRulesTests, testSimpleEligibleSession) */
  var XP_25 = 25;
  var initHowHud = safe(function(root){
    within(root, '[data-how]').forEach(function(sec){
      if (sec.__lumiHud) return; sec.__lumiHud = 1;
      var steps = $$('.step', sec), huds = $$('[data-how-hud]', sec);
      if (steps.length < 3 || !huds.length) return;
      var kept = false, last = '';
      function prog(el, frac){ var r = el.getBoundingClientRect(), mid = window.innerHeight * .5; return Math.max(0, Math.min(1, (mid - r.top) / Math.max(1, r.height * frac))); }
      function update(){
        /* minutes tick through the focus step, XP lands on the last (kept) step */
        var p2 = prog(steps[steps.length - 2], 1), p3 = prog(steps[steps.length - 1], .45);
        var mins = Math.round(25 * p2), xp = Math.round(XP_25 * p3);
        var face = xp >= XP_25 ? 'done' : p2 > 0 ? 'focus' : 'ready';
        var key = mins + '|' + xp + '|' + face;
        if (key === last) return; last = key;
        huds.forEach(function(h){
          h.setAttribute('data-face', face);
          var m = $('[data-hud-min]', h), x = $('[data-hud-xp]', h);
          if (m) m.textContent = mins; if (x) x.textContent = xp;
          h.style.setProperty('--hud-p', p2.toFixed(3));
        });
        var now = xp >= XP_25;
        if (now !== kept){
          kept = now;
          huds.forEach(function(h){ h.classList.toggle('kept', now); });
          if (now) huds.forEach(function(h){ if (inView(h)) confetti(h); });
        }
      }
      var ticking = false;
      window.addEventListener('scroll', function(){ if (ticking) return; ticking = true; requestAnimationFrame(function(){ ticking = false; update(); }); }, {passive:true});
      window.addEventListener('resize', update);
      update();
    });
  });

  /* ---- DESIGN: tap to put Lumi next to everyday things, drawn to scale in millimetres ---- */
  var initSize = safe(function(root){
    within(root, '[data-size]').forEach(function(t){
      if (t.__lumiSize) return; t.__lumiSize = 1;
      var items = $$('[data-size-item]', t), btn = $('[data-size-next]', t), stage = $('[data-size-stage]', t), lumi = $('.cmp-lumi', t);
      var nm = $('[data-size-name]', t), nt = $('[data-size-note]', t), ix = $('[data-size-i]', t), i = 0;
      if (!items.length) return;
      items.forEach(function(it, k){ if (it.classList.contains('on')) i = k; });
      function show(k){
        items[i].classList.remove('on');
        i = k; var it = items[i];
        it.classList.add('on');
        if (nm) nm.textContent = it.getAttribute('data-name');
        if (nt) nt.textContent = it.getAttribute('data-note');
        if (ix) ix.textContent = i + 1;
        if (lumi){ lumi.setAttribute('data-face', it.getAttribute('data-face') || 'side'); again(lumi, 'hop'); }
      }
      function next(){ show((i + 1) % items.length); buzz(8); }
      /* the whole tile is the tap target (the Swap it button inside it included), so a tap anywhere swaps */
      t.addEventListener('click', function(e){ if (e.target.closest('a')) return; next(); });
      if (lumi) lumi.setAttribute('data-face', items[i].getAttribute('data-face') || 'side');
    });
  });

  /* ---- COLOURS: the picked shell colour floods the section from the swatch outwards, and Lumi hops ----
     app.js initColours still swaps the render, the name and the order form, and fires 'lumi:colour'. */
  var initFlood = safe(function(root){
    within(root, '[data-flood-scope]').forEach(function(sec){
      if (sec.__lumiFlood) return; sec.__lumiFlood = 1;
      var wipe = $('.flood-wipe', sec), hop = $('.cs-hop', sec), burst = $('.cs-burst', sec), stage = $('.colour-stage', sec);
      var line = $('[data-colour-line]', sec), name = $('.sw-name', sec);
      var bubble = line && (line.closest('.cs-bubble') || line), face = $('.cs-face', sec), faceT = 0;
      var cur = (sec.style.getPropertyValue('--flood') || '').trim().toUpperCase(), pending = null, t1 = 0, t2 = 0;
      function commit(col, dark){ sec.style.setProperty('--flood', col); sec.classList.toggle('is-dark', !!dark); }
      sec.addEventListener('lumi:colour', function(e){
        var sw = e.detail && e.detail.swatch; if (!sw) return;
        var col = (sw.getAttribute('data-flood') || '').toUpperCase(), dark = sw.hasAttribute('data-dark');
        if (line && sw.getAttribute('data-line')){ line.textContent = sw.getAttribute('data-line'); again(bubble, 'pop'); }
        /* Lumi's face on the bubble: a big grin for every pick, then the mood that colour puts Lumi in (data-mood) */
        if (face){
          face.setAttribute('data-face', 'done'); again(face, 'pop');
          clearTimeout(faceT); faceT = setTimeout(function(){ face.setAttribute('data-face', sw.getAttribute('data-mood') || 'ready'); }, 1400);
        }
        again(name, 'pop'); again(hop, 'hop'); again(burst, 'pop'); again(stage, 'sparkle');
        if (!col || col === cur) return;
        cur = col;
        if (pending){ commit(pending.col, pending.dark); }
        clearTimeout(t1); clearTimeout(t2);
        if (reduce || !wipe){ commit(col, dark); pending = null; return; }
        var sr = sec.getBoundingClientRect(), br = sw.getBoundingClientRect();
        var x = br.left + br.width / 2 - sr.left, y = br.top + br.height / 2 - sr.top;
        var r = Math.ceil(Math.sqrt(Math.pow(Math.max(x, sr.width - x), 2) + Math.pow(Math.max(y, sr.height - y), 2))) + 24;
        wipe.classList.remove('go');
        wipe.style.setProperty('--wipe', col); wipe.style.setProperty('--wx', x + 'px'); wipe.style.setProperty('--wy', y + 'px'); wipe.style.setProperty('--wr', r + 'px');
        void wipe.getBoundingClientRect();
        wipe.classList.add('go');
        pending = {col: col, dark: dark};
        t1 = setTimeout(function(){ sec.classList.toggle('is-dark', dark); }, 430);
        t2 = setTimeout(function(){ commit(col, dark); pending = null; wipe.classList.remove('go'); }, 840);
      });
    });
  });

  var ALL = [initBlink, initFilmLumi, initHowHud, initSize, initFlood];
  window.LumiInit = window.LumiInit || [];
  ALL.forEach(function(fn){ window.LumiInit.push(fn); fn(document); });
})();

/* Lumi part 3 (26 Sep 2026): the concepts strip on phones, the inside view waking up, the folding specs, the
   October beta wall saying hi, and the little Lumi who walks the roadmap. No libraries.
   Every init runs inside a root element and marks what it has set up, so Shopify's theme editor can re-run it for
   a re-rendered section. Lumi's faces are drawn inline here (the same drawings as the sprite at the top of
   index.html), so the theme sections work without that sprite. Anything missing on a page is simply skipped. */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s,r){return (r||document).querySelector(s)};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var within = function(root, sel){ var out = $$(sel, root); if (root.matches && root.matches(sel)) out.unshift(root); return out; };
  var buzz = function(ms){ if (!navigator.vibrate) return; if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return; try{navigator.vibrate(ms)}catch(e){} };
  var safe = function(fn){ return function(root){ try { fn(root || document); } catch(e){ if (window.console) console.warn('lumi:', e); } }; };
  var again = function(el, cls){ if (!el || reduce) return; el.classList.remove(cls); void el.getBoundingClientRect(); el.classList.add(cls); };

  /* ---- Lumi's faces, 120 x 80, the same as the hero sprite ---- */
  var CHEEK = function(y, r, o){ return '<g fill="#F2BFCF" opacity="' + (o || '.85') + '"><circle cx="21" cy="' + y + '" r="' + r + '"/><circle cx="99" cy="' + y + '" r="' + r + '"/></g>'; };
  var INK = '#13223A';
  var F = {idle:'<g fill="#F2BFCF" opacity=".85"><circle cx="14.4" cy="54.8" r="8.3"/><circle cx="105.6" cy="54.8" r="8.3"/></g><g fill="'+INK+'"><circle cx="30.7" cy="38.8" r="9.2"/><circle cx="89.3" cy="38.8" r="9.2"/></g><g fill="#FFFDF9"><circle cx="28.1" cy="35.9" r="2.9"/><circle cx="86.7" cy="35.9" r="2.9"/></g><path d="M49.1 47.7C52.2 56.3 67.8 56.3 70.9 47.7" fill="none" stroke="'+INK+'" stroke-width="3.8" stroke-linecap="round"/>',blink:'<g fill="#F2BFCF" opacity=".85"><circle cx="14.4" cy="54.8" r="8.3"/><circle cx="105.6" cy="54.8" r="8.3"/></g><path d="M22.7 40q8 5 16 0M81.3 40q8 5 16 0" fill="none" stroke="'+INK+'" stroke-width="3.8" stroke-linecap="round"/><path d="M49.1 47.7C52.2 56.3 67.8 56.3 70.9 47.7" fill="none" stroke="'+INK+'" stroke-width="3.8" stroke-linecap="round"/>',ready:'<g fill="#F2BFCF" opacity=".85"><circle cx="14.4" cy="54.8" r="8.3"/><circle cx="105.6" cy="54.8" r="8.3"/></g><g fill="'+INK+'"><circle cx="30.7" cy="38.2" r="9.8"/><circle cx="89.3" cy="38.2" r="9.8"/></g><g fill="#FFFDF9"><circle cx="28.1" cy="35.3" r="2.9"/><circle cx="86.7" cy="35.3" r="2.9"/></g><path d="M49.1 47.7C52.2 56.3 67.8 56.3 70.9 47.7" fill="none" stroke="'+INK+'" stroke-width="3.8" stroke-linecap="round"/>',done:'<g fill="#F2BFCF" opacity=".9"><circle cx="14.4" cy="54.8" r="8.3"/><circle cx="105.6" cy="54.8" r="8.3"/></g><g fill="'+INK+'"><circle cx="30.7" cy="38.8" r="9.2"/><circle cx="89.3" cy="38.8" r="9.2"/></g><g fill="#FFFDF9"><circle cx="28.1" cy="35.9" r="2.9"/><circle cx="86.7" cy="35.9" r="2.9"/></g><path d="M49.1 47.7C52.2 56.3 67.8 56.3 70.9 47.7" fill="none" stroke="'+INK+'" stroke-width="3.8" stroke-linecap="round"/>',watch:'<g fill="#F2BFCF" opacity=".85"><circle cx="14.4" cy="54.8" r="8.3"/><circle cx="105.6" cy="54.8" r="8.3"/></g><g fill="'+INK+'"><circle cx="30.7" cy="41.4" r="9.2"/><circle cx="89.3" cy="41.4" r="9.2"/></g><g fill="#FFFDF9"><circle cx="28.1" cy="38.5" r="2.9"/><circle cx="86.7" cy="38.5" r="2.9"/></g><path d="M49.1 48.5C52.2 57.1 67.8 57.1 70.9 48.5" fill="none" stroke="'+INK+'" stroke-width="3.8" stroke-linecap="round"/>',side:'<g fill="#F2BFCF" opacity=".85"><circle cx="14.4" cy="54.8" r="8.3"/><circle cx="105.6" cy="54.8" r="8.3"/></g><g fill="'+INK+'"><circle cx="35.7" cy="38.8" r="9.2"/><circle cx="94.3" cy="38.8" r="9.2"/></g><g fill="#FFFDF9"><circle cx="33.1" cy="35.9" r="2.9"/><circle cx="91.7" cy="35.9" r="2.9"/></g><path d="M52.1 47.7C55.2 56.3 70.8 56.3 73.9 47.7" fill="none" stroke="'+INK+'" stroke-width="3.8" stroke-linecap="round"/>'};
  var GLASS = '<rect width="120" height="80" rx="18" fill="#E3EBF3"/><path d="M84 0h14L60 80H46z" fill="#FFFDF9" opacity=".5"/>';
  var SHELL = '<g stroke="#2E2A24" stroke-width="3" stroke-linejoin="round" style="fill:var(--lumi-body,#EBD7BF)"><circle cx="50" cy="10" r="6.4" fill="none" stroke-width="7.4"/><circle cx="50" cy="10" r="6.4" fill="none" style="stroke:var(--lumi-body,#EBD7BF)" stroke-width="2.6"/><ellipse cx="10" cy="70" rx="7.6" ry="13.5" transform="rotate(20 10 70)"/><ellipse cx="90" cy="70" rx="7.6" ry="13.5" transform="rotate(-20 90 70)"/><ellipse cx="34" cy="113" rx="11.5" ry="8"/><ellipse cx="66" cy="113" rx="11.5" ry="8"/><path d="M50 15C75 15 86 32 86 54L87 94C87 109 72 116 50 116C28 116 13 109 13 94L14 54C14 32 25 15 50 15Z"/><rect x="24.5" y="35.5" width="51" height="36" rx="11" fill="#2E2A24" style="fill:#2E2A24"/><circle cx="50" cy="91" r="9.5" fill="none" style="fill:none" stroke="#E2B35E" stroke-width="3"/><circle cx="50" cy="91" r="5" fill="none" style="fill:none" stroke="#2E2A24" stroke-opacity=".22" stroke-width="1.5"/></g>';
  var STAR = 'M10 1.5c.8 4.6 3.9 7.7 8.5 8.5-4.6.8-7.7 3.9-8.5 8.5-.8-4.6-3.9-7.7-8.5-8.5 4.6-.8 7.7-3.9 8.5-8.5z';
  var BURST = 'M60 2L68.7 10.8L79.8 5.5L85 16.7L97.3 15.6L98.3 27.9L110.2 31L107 42.9L117.1 49.9L110 60L117.1 70.1L107 77.1L110.2 89L98.3 92.1L97.3 104.4L85 103.3L79.8 114.5L68.7 109.2L60 118L51.3 109.2L40.2 114.5L35 103.3L22.7 104.4L21.7 92.1L9.8 89L13 77.1L2.9 70.1L10 60L2.9 49.9L13 42.9L9.8 31L21.7 27.9L22.7 15.6L35 16.7L40.2 5.5L51.3 10.8Z';
  function faces(list){ return list.map(function(k){ return '<g class="fc fc-' + k + '">' + F[k] + '</g>'; }).join(''); }
  /* a screen face in its dark bezel, 132 x 92 */
  function screen(list){ return '<svg viewBox="0 0 132 92" aria-hidden="true"><rect x="2" y="2" width="128" height="88" rx="24" fill="#2E2A24"/><svg x="9" y="8" width="114" height="76" viewBox="0 0 120 80">' + GLASS + faces(list) + '</svg></svg>'; }
  /* the whole flat Lumi, 100 x 124 */
  function body(list){ return '<svg class="lumi-svg" viewBox="0 0 100 124" aria-hidden="true">' + SHELL + '<svg x="27.5" y="38.5" width="45" height="30" viewBox="0 0 120 80">' + GLASS + faces(list) + '</svg></svg>'; }
  function star(cls, fill){ return '<svg class="' + cls + '" viewBox="0 0 20 20" aria-hidden="true"><path d="' + STAR + '" fill="' + (fill || '#F5A623') + '" stroke="#2E2A24" stroke-width="1.5" stroke-linejoin="round"/></svg>'; }

  /* blink now and then while on screen, unless something else is driving the face (el.__busy) */
  function blinker(el){
    if (reduce || el.__lumiBlinker) return; el.__lumiBlinker = 1;
    var vis = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ vis = es[0].isIntersecting; }).observe(el);
    (function loop(){
      setTimeout(function(){
        if (vis && !document.hidden && !el.__busy){
          el.setAttribute('data-blink', '');
          setTimeout(function(){ el.removeAttribute('data-blink'); }, 150);
        }
        loop();
      }, 2300 + Math.random() * 3600);
    })();
  }

  /* now and then one of the Lumis in view gives a little hop, so a wall of them never sits frozen.
     Only while the section is on screen and the tab is visible; never for reduced motion. */
  function fidget(sec, list, cls, every, dur){
    if (reduce || sec['__lumiFidget' + cls]) return; sec['__lumiFidget' + cls] = 1;
    var vis = false;
    if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ vis = es[0].isIntersecting; }).observe(sec);
    setInterval(function(){
      if (!vis || document.hidden) return;
      var vh = window.innerHeight, vw = window.innerWidth;
      var els = list().filter(function(el){
        if (el.classList.contains(cls) || el.classList.contains('hide') || el.classList.contains('is-picked') || el.matches(':hover')) return false;
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.bottom > 40 && r.top < vh - 70 && (Math.min(r.right, vw) - Math.max(r.left, 0)) / r.width > .6;
      });
      if (!els.length) return;
      var el = els[Math.floor(Math.random() * els.length)];
      el.classList.add(cls); setTimeout(function(){ el.classList.remove(cls); }, dur);
    }, every);
  }

  /* ================= CONCEPTS: a swipe strip on phones, a face that cheers your hearts ================= */
  var initConceptStrip = safe(function(root){
    within(root, '[data-concepts]').forEach(function(sec){
      if (sec.__lumiStrip) return; sec.__lumiStrip = 1;
      var grid = $('.cgrid', sec); if (!grid) return;
      var mq = window.matchMedia('(max-width: 560px)');
      var ctl = document.createElement('div'); ctl.className = 'cs-ctl';
      ctl.innerHTML = '<button type="button" class="cs-arrow" data-dir="-1" aria-label="Previous concept"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 5.5L8 12l6.5 6.5"/></svg></button>' +
        '<span class="cs-count" aria-live="polite"></span>' +
        '<button type="button" class="cs-arrow" data-dir="1" aria-label="Next concept"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 5.5L16 12l-6.5 6.5"/></svg></button>';
      grid.parentNode.insertBefore(ctl, grid.nextSibling);
      var count = $('.cs-count', ctl), mid = -1;
      function cards(){ return $$('.ct', grid).filter(function(c){ return !c.classList.contains('hide'); }); }
      function measure(){
        grid.tabIndex = mq.matches ? 0 : -1;
        if (!mq.matches){ $$('.ct.is-mid', grid).forEach(function(c){ c.classList.remove('is-mid'); }); mid = -1; return; }
        var cs = cards(), gr = grid.getBoundingClientRect(), cx = gr.left + gr.width / 2, best = 0, bd = 1e9;
        cs.forEach(function(c, i){ var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - cx); if (d < bd){ bd = d; best = i; } });
        cs.forEach(function(c, i){ c.classList.toggle('is-mid', i === best); });
        if (best !== mid || !count.textContent){ mid = best; count.textContent = 'Concept ' + (best + 1) + ' of ' + cs.length; }
      }
      function go(dir){
        var cs = cards(), t = cs[Math.max(0, Math.min(cs.length - 1, (mid < 0 ? 0 : mid) + dir))]; if (!t) return;
        grid.scrollTo({left: t.offsetLeft - (grid.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth'});
      }
      var rq = 0;
      grid.addEventListener('scroll', function(){ if (!rq) rq = requestAnimationFrame(function(){ rq = 0; measure(); }); }, {passive:true});
      $$('.cs-arrow', ctl).forEach(function(b){ b.addEventListener('click', function(){ go(+b.getAttribute('data-dir')); buzz(6); }); });
      grid.addEventListener('keydown', function(e){
        if (!mq.matches) return;
        if (e.key === 'ArrowRight'){ e.preventDefault(); go(1); } else if (e.key === 'ArrowLeft'){ e.preventDefault(); go(-1); }
      });
      /* a new filter starts the strip again from its first card */
      $$('.chip', sec).forEach(function(c){ c.addEventListener('click', function(){ setTimeout(function(){ grid.scrollLeft = 0; mid = -1; measure(); }, 0); }); });
      /* mouse drag with a grab cursor (touch swipes natively and snaps) */
      var down = false, sx = 0, sl = 0, moved = false;
      grid.addEventListener('pointerdown', function(e){ if (!mq.matches || e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = grid.scrollLeft; });
      window.addEventListener('pointermove', function(e){ if (!down) return; var dx = e.clientX - sx; if (!moved && Math.abs(dx) > 5){ moved = true; grid.classList.add('dragging'); } if (moved) grid.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function(){ if (!down) return; down = false; if (moved){ grid.classList.remove('dragging'); measure(); go(0); } });
      grid.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      if (mq.addEventListener) mq.addEventListener('change', measure); else if (mq.addListener) mq.addListener(measure);
      window.addEventListener('resize', function(){ measure(); });
      measure();
      /* a concept in view does a small hop a little under every second (on phones, the card in the middle every 1.7 s) */
      fidget(sec, function(){ return $$('.ct', grid); }, 'wig', mq.matches ? 1700 : 800, 900);

      /* the picks bar gets Lumi's face: happy when you heart one, a sideways look when you take one back */
      var bar = $('.picks', sec);
      if (bar && !$('.pk-face', bar)){
        var pf = document.createElement('span'); pf.className = 'pk-face'; pf.setAttribute('aria-hidden', 'true'); pf.setAttribute('data-face', 'idle');
        pf.innerHTML = screen(['idle', 'blink', 'done', 'side']);
        bar.insertBefore(pf, bar.firstChild); blinker(pf);
        var pt = 0;
        sec.addEventListener('click', function(e){
          var h = e.target.closest && e.target.closest('.heart'); if (!h) return;
          var on = h.getAttribute('aria-pressed') === 'true', card = h.closest('.ct');
          pf.__busy = 1; pf.setAttribute('data-face', on ? 'done' : 'side'); again(pf, 'pop');
          if (on) again(card, 'hop');
          clearTimeout(pt); pt = setTimeout(function(){ pf.setAttribute('data-face', 'idle'); pf.__busy = 0; }, 1500);
        });
      }
    });
  });

  /* ================= INSIDE: once Lumi is built, the screen switches on and Lumi blinks at you ================= */
  var initScrubWake = safe(function(root){
    within(root, '[data-scrub]').forEach(function(sec){
      if (sec.__lumiWake) return; sec.__lumiWake = 1;
      var frame = $('.scrub-frame', sec); if (!frame || reduce) return;
      /* the glass of the finished render, traced from the clip's last frame (1600 x 900): x 673 to 924, y 277 to 441 */
      var GL = 'M0 42C0 6 8 0 60 0S120 6 120 42V64C120 76 116 80 106 80H14C4 80 0 76 0 64Z';
      var w = document.createElement('div'); w.className = 'scrub-wake'; w.setAttribute('aria-hidden', 'true'); w.setAttribute('data-face', 'blink');
      w.innerHTML = '<svg viewBox="0 0 120 80" preserveAspectRatio="none">' +
        '<path class="sw-off" d="' + GL + '" fill="#1E212C" stroke="#1E212C" stroke-width="9" stroke-linejoin="round"/>' +
        '<g class="sw-on"><path d="' + GL + '" fill="#E3EBF3"/><path d="M86 0h13L62 80H48z" fill="#FFFDF9" opacity=".45"/>' + faces(['blink', 'idle', 'ready', 'done']) + '</g>' +
        '<path class="sw-flash" d="' + GL + '" fill="#FFFDF9"/></svg>';
      var hi = document.createElement('p'); hi.className = 'scrub-hi'; hi.setAttribute('aria-hidden', 'true'); hi.textContent = 'Hi. All in one piece.';
      var sp = document.createElement('span'); sp.className = 'scrub-spk'; sp.setAttribute('aria-hidden', 'true');
      sp.innerHTML = star('sk sk-1') + star('sk sk-2', '#FFFDF9') + star('sk sk-3');
      /* 27 Sep (Xavier): the finished Lumi keeps the render's own face, exactly as in the last frame of the clip.
         The drawn overlay face (w) is no longer shown; only the bubble and the sparks react. */
      frame.appendChild(sp); frame.appendChild(hi);
      var live = document.createElement('p'); live.className = 'sr-only'; live.setAttribute('aria-live', 'polite'); frame.appendChild(live);
      var awake = false, timers = [];
      function later(fn, ms){ timers.push(setTimeout(fn, ms)); }
      function face(f){ w.setAttribute('data-face', f); }
      function reset(){
        timers.forEach(clearTimeout); timers = []; awake = false; w.__busy = 1;
        w.className = 'scrub-wake'; face('blink'); hi.classList.remove('show'); sec.classList.remove('awake'); live.textContent = '';
      }
      function wake(){
        awake = true; w.__busy = 1;
        later(function(){ hi.classList.add('show'); sec.classList.add('awake'); again(sp, 'go'); live.textContent = 'Lumi is built, all in one piece.'; }, 260);
        later(function(){ w.__busy = 0; }, 1200);                                     /* from here Lumi blinks unprompted */
      }
      sec.addEventListener('lumi:scrub', function(e){
        var vp = e.detail ? e.detail.vp : 0;
        if (vp >= 1 && !awake) wake();
        else if (vp < 0.96 && awake) reset();
      });
      /* hover or tap Lumi once awake and Lumi grins */
      function grin(){ if (!awake || w.__busy) return; again(sp, 'go'); }
      frame.addEventListener('mouseenter', grin);
      frame.addEventListener('click', function(){ if (!awake || w.__busy) return; again(sp, 'go'); buzz(10); });
      w.__busy = 1; blinker(w);
    });
  });

  /* ================= SPECS: folded behind a friendly button ================= */
  var initSpecs = safe(function(root){
    within(root, '[data-specs]').forEach(function(sec){
      if (sec.__lumiSpecs) return; sec.__lumiSpecs = 1;
      var btn = $('[data-specs-toggle]', sec), bodyEl = $('.sp-body', sec), lbl = $('[data-specs-label]', sec), fc = $('.sp-face', sec);
      if (!btn || !bodyEl) return;
      if (fc && !fc.firstChild){ fc.innerHTML = screen(['watch', 'blink', 'side', 'ready', 'done']); blinker(fc); }
      $$('.spec', sec).forEach(function(s, i){ s.style.setProperty('--i', i); });
      var ft = 0;
      function set(open, animate){
        sec.classList.toggle('open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) bodyEl.removeAttribute('inert'); else bodyEl.setAttribute('inert', '');
        if (lbl) lbl.textContent = open ? 'Fold the numbers away' : 'Show me the numbers';
        if (!fc) return;
        clearTimeout(ft);
        if (open){ fc.__busy = 1; fc.setAttribute('data-face', 'done'); ft = setTimeout(function(){ fc.setAttribute('data-face', 'ready'); fc.__busy = 0; }, 1300); }
        else { fc.__busy = 0; fc.setAttribute('data-face', 'watch'); }
        if (animate) again(fc, 'pop');
      }
      sec.classList.add('sp-ready');
      set(false, false);
      btn.addEventListener('click', function(){ set(!sec.classList.contains('open'), true); buzz(8); });
      btn.addEventListener('mouseenter', function(){ if (fc && !fc.__busy && !sec.classList.contains('open')) fc.setAttribute('data-face', 'side'); });
      btn.addEventListener('mouseleave', function(){ if (fc && !fc.__busy && !sec.classList.contains('open')) fc.setAttribute('data-face', 'watch'); });
    });
  });

  /* ================= OCTOBER BETA: tap a Lumi on the wall and it pops forward to say hi ================= */
  var NAMES = ['terrazzo','frosted clear','midnight gloss','pearl','lilac','cookies and cream','sage','blush','peach sunset','caramel fade','sticker trio','crochet','denim','teddy fleece','pastel marble','doodles','cow print','checkerboard','sticker bomb','beaded charms','funfetti','sticky note','highlighter','stars and moons','washi tape','biscuit','fruit salad','rainbow fluff','donut drip','candy fleece','onigiri','cereal loops','mint chip','lemon sorbet','powder blue','tangerine','cherry red','forest green','lavender gingham','picnic gingham','leopard','zebra','tie dye','galaxy','chrome','brushed gold','rose gold','holographic','glow','light oak','walnut','cork','cable knit','corduroy','tweed','saddle leather','emerald velvet','matcha latte','strawberry milk','blueberry','watermelon','avocado','bubble tea','honeycomb','clouds','rainbow stripes','navy polka','pinstripe','pastel camo','tartan','paint splatter','pixel','circuit','carrara','granite','concrete','ceramic glaze','delft','sakura','sunflower','lemon print','toadstool','frog','penguin','panda','tiger','dalmatian','sheep wool','dove velour','neon pink','neon lime','glitter','aurora','sunset','great wave','terracotta','river pebble','rubber duck','mocha','frost'];
  var HELLO = ['Hi! You found me.', 'Oh, hello there!', 'Hi! Nice to meet you.'];
  var cap = function(s){ return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; };
  var initBetaPick = safe(function(root){
    within(root, '[data-beta]').forEach(function(sec){
      var wall = $('.beta-wall', sec); if (!wall || wall.__lumiPick) return;
      var tiles = $$('.bt', wall); if (!tiles.length) return;
      wall.__lumiPick = 1;
      tiles.forEach(function(t){ var no = +t.getAttribute('data-no'); if (no && NAMES[no - 1]) t.setAttribute('aria-label', 'Say hi to concept ' + no + ', ' + NAMES[no - 1]); });
      /* the wall leans; the hello card sits over it straight, so the wall gets a plain box around it */
      var box = document.createElement('div'); box.className = 'bw-box';
      wall.parentNode.insertBefore(box, wall); box.appendChild(wall);
      var tip = document.createElement('p'); tip.className = 'bw-tip'; tip.setAttribute('aria-hidden', 'true');
      tip.innerHTML = '<span>Tap a Lumi<svg viewBox="0 0 56 36"><path d="M3 7c17-6 36-3 46 20" stroke="#2E2A24" stroke-width="3" fill="none" stroke-linecap="round"/><path d="M40 22l9 6 3-11" stroke="#2E2A24" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      box.appendChild(tip);
      var cta = $('a[href*="batch=beta"]', sec), href = cta ? cta.getAttribute('href') : 'reserve.html?batch=beta';
      var pop = document.createElement('div'); pop.className = 'bw-pop'; pop.setAttribute('role', 'dialog'); pop.setAttribute('aria-label', 'Say hi'); pop.hidden = true;
      pop.innerHTML = '<button type="button" class="bw-x" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg></button>' +
        '<div class="bw-stage"><svg class="bw-burst" viewBox="0 0 120 120" aria-hidden="true"><path d="' + BURST + '"/></svg><img class="bw-img" alt="" width="150" height="200">' +
        star('bw-spk bw-spk-1') + star('bw-spk bw-spk-2', '#FFFDF9') + star('bw-spk bw-spk-3') + '</div>' +
        '<p class="bw-hi"><span class="bw-face" data-face="done" aria-hidden="true">' + screen(['done', 'ready', 'blink']) + '</span><span class="bw-say"></span></p>' +
        '<p class="bw-name"></p>' +
        '<p class="bw-note">A concept finish. Cream ships first. We\'ll confirm your colour before it ships.</p>' +
        '<a class="btn btn-glow" href="' + href + '">Reserve a beta place</a>';
      box.appendChild(pop);
      var img = $('.bw-img', pop), say = $('.bw-say', pop), nameEl = $('.bw-name', pop), fc = $('.bw-face', pop);
      var cur = null, n = 0, ft = 0;
      blinker(fc);
      function srcOf(t){ var m = (t.style.backgroundImage || '').match(/url\(["']?([^"')]+)["']?\)/); return m ? m[1] : ''; }
      function place(t){
        var br = box.getBoundingClientRect(), tr = t.getBoundingClientRect(), ph = pop.offsetHeight;
        var top = tr.top - br.top + tr.height / 2 - ph / 2;
        pop.style.top = Math.round(Math.max(-12, Math.min(br.height - ph + 12, top))) + 'px';
      }
      function open(t){
        if (cur) cur.classList.remove('is-picked');
        cur = t; t.classList.add('is-picked'); box.classList.add('has-pick');
        var no = +t.getAttribute('data-no'), nm = NAMES[no - 1] || '';
        var src = srcOf(t) || (wall.getAttribute('data-srcs') || '').split(',')[+t.getAttribute('data-k')] || '';
        /* the wall tile is 150 x 200; the card shows it at that size, so 2x screens get the 300 x 400 twin (w-001-2x.webp) */
        if (src){ var s2 = src.replace(/(w-\d{3})\.webp/, '$1-2x.webp'); if (s2 !== src) img.srcset = src + ' 1x, ' + s2 + ' 2x'; else img.removeAttribute('srcset'); img.src = src; }
        img.alt = nm ? 'Concept render of Lumi in ' + nm : 'Concept render of Lumi';
        say.textContent = HELLO[n++ % HELLO.length];
        nameEl.textContent = (no ? 'Concept no. ' + no + (nm ? ' · ' : '') : '') + cap(nm);
        pop.hidden = false; place(t);
        pop.setAttribute('aria-label', 'Say hi to ' + (nm || 'this Lumi'));
        fc.__busy = 1; fc.setAttribute('data-face', 'done');
        clearTimeout(ft); ft = setTimeout(function(){ fc.setAttribute('data-face', 'ready'); fc.__busy = 0; }, 1700);
        if (!reduce){
          /* it pops forward out of its tile */
          pop.classList.remove('in');
          var ir = img.getBoundingClientRect(), tr = t.getBoundingClientRect();
          if (ir.width){
            var s = tr.width / ir.width, dx = tr.left + tr.width / 2 - (ir.left + ir.width / 2), dy = tr.top + tr.height / 2 - (ir.top + ir.height / 2);
            img.style.transition = 'none'; img.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
            void img.getBoundingClientRect();
            img.style.transition = ''; img.style.transform = '';
          }
          void pop.offsetWidth; pop.classList.add('in');
        } else pop.classList.add('in');
        buzz(12);
      }
      function close(back){
        if (!cur) return;
        pop.classList.remove('in'); pop.hidden = true; cur.classList.remove('is-picked'); box.classList.remove('has-pick');
        if (back) cur.focus();
        cur = null;
      }
      /* once the wall has filled in, a random Lumi on it pops up to say hi every so often */
      fidget(sec, function(){ return wall.classList.contains('go') ? tiles : []; }, 'wig', 650, 700);
      wall.addEventListener('click', function(e){
        var t = e.target.closest && e.target.closest('.bt'); if (!t) return;
        if (t === cur){ close(); return; }
        open(t);
      });
      $('.bw-x', pop).addEventListener('click', function(){ close(true); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && cur) close(true); });
      document.addEventListener('click', function(e){ if (cur && !box.contains(e.target)) close(); });
      window.addEventListener('resize', function(){ if (cur) place(cur); });
      /* one tab stop for the whole wall; arrow keys move between Lumis */
      wall.addEventListener('keydown', function(e){
        var t = e.target.closest && e.target.closest('.bt'); if (!t) return;
        var cols = getComputedStyle(wall).gridTemplateColumns.split(' ').length || 10, i = tiles.indexOf(t), j = i;
        if (e.key === 'ArrowRight') j = i + 1; else if (e.key === 'ArrowLeft') j = i - 1;
        else if (e.key === 'ArrowDown') j = i + cols; else if (e.key === 'ArrowUp') j = i - cols;
        else if (e.key === 'Home') j = 0; else if (e.key === 'End') j = tiles.length - 1; else return;
        e.preventDefault(); j = Math.max(0, Math.min(tiles.length - 1, j));
        t.tabIndex = -1; tiles[j].tabIndex = 0; tiles[j].focus();
      });
    });
  });

  /* ================= ROADMAP: a small Lumi walks the line to "You are here" as it fills ================= */
  var initRoadmapLumi = safe(function(root){
    within(root, '.rm-track').forEach(function(track){
      if (track.__lumiRm) return; track.__lumiRm = 1;
      var line = $('.rm-line', track), now = $('.ms.now', track), dots = $$('.ms .dot', track);
      if (!line || !now || !dots.length) return;
      var nowDot = $('.dot', now);
      var lu = document.createElement('div'); lu.className = 'rm-lumi'; lu.setAttribute('aria-hidden', 'true'); lu.setAttribute('data-face', 'idle');
      lu.innerHTML = '<span class="rm-bob">' + body(['idle', 'blink', 'side', 'ready', 'done']) + '</span><span class="rm-say">We\'re here!</span>';
      track.appendChild(lu);
      function cx(el){ var r = el.getBoundingClientRect(), tr = track.getBoundingClientRect(); return r.left - tr.left - track.clientLeft + track.scrollLeft + r.width / 2; }
      var started = false, arrived = false, walking = false, fill = $('.rm-fill', track);
      function spots(){
        var W = lu.offsetWidth || 46, H = lu.offsetHeight || 57;
        return { top: line.offsetTop - H + 6, from: cx(dots[0]) - W / 2, to: cx(nowDot) - W - 12, end: cx(nowDot) - line.offsetLeft };
      }
      /* the line runs from the first milestone to the last one, not just across the first screen */
      function size(){
        var a = cx(dots[0]), b = cx(dots[dots.length - 1]);
        line.style.left = (a - 8) + 'px'; line.style.right = 'auto'; line.style.width = (b - a + 16) + 'px';
        var s = spots(); lu.style.top = s.top + 'px';
        if (!walking){ lu.style.transition = 'none'; lu.style.left = (arrived ? s.to : s.from) + 'px'; void lu.offsetWidth; lu.style.transition = ''; }
      }
      function arrive(){
        if (arrived) return;
        walking = false; arrived = true; lu.classList.remove('walk'); lu.classList.add('arrived');
        lu.__busy = 1; lu.setAttribute('data-face', 'done'); again(lu, 'hop');
        setTimeout(function(){ lu.setAttribute('data-face', 'ready'); lu.__busy = 0; }, 1500);
      }
      /* Lumi rides the front of the fill: every frame the spot is the fill's progress, so the two can never drift apart */
      function walk(){
        if (started) return; started = true;
        var s = spots();
        if (reduce || !fill){ lu.style.left = s.to + 'px'; arrive(); return; }
        walking = true; lu.__busy = 1; lu.classList.add('walk', 'riding'); lu.setAttribute('data-face', 'side');
        var t0 = performance.now(), endW = parseFloat(fill.style.width) || s.end;
        (function step(now){
          var p = Math.max(0, Math.min(1, fill.getBoundingClientRect().width / Math.max(1, endW)));
          lu.style.left = (s.from + (s.to - s.from) * p).toFixed(1) + 'px';
          if (p < .995 && now - t0 < 4000) requestAnimationFrame(step);
          else { lu.classList.remove('riding'); lu.style.left = s.to + 'px'; arrive(); }
        })(t0);
      }
      size();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
      window.addEventListener('load', size);
      var rt = 0; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(size, 150); });
      /* app.js starts the fill once the line is well on screen and tells us with lumi:rm-go; we start on the same frame */
      if (track.classList.contains('rm-go')) walk();
      else track.addEventListener('lumi:rm-go', walk);
      /* drag or swipe the track and Lumi looks the way it is going */
      var last = track.scrollLeft, st = 0;
      track.addEventListener('scroll', function(){
        var d = track.scrollLeft - last; last = track.scrollLeft;
        if (!d || walking) return;
        lu.__busy = 1; lu.setAttribute('data-face', 'side'); lu.classList.toggle('look-l', d < 0);
        clearTimeout(st); st = setTimeout(function(){ lu.classList.remove('look-l'); lu.setAttribute('data-face', arrived ? 'ready' : 'idle'); lu.__busy = 0; }, 450);
      }, {passive:true});
      /* poke Lumi and Lumi hops */
      lu.addEventListener('click', function(){ if (walking) return; lu.__busy = 1; lu.setAttribute('data-face', 'done'); again(lu, 'hop'); buzz(10);
        setTimeout(function(){ lu.setAttribute('data-face', arrived ? 'ready' : 'idle'); lu.__busy = 0; }, 1200); });
      blinker(lu);
    });
  });

  var ALL = [initConceptStrip, initScrubWake, initSpecs, initBetaPick, initRoadmapLumi];
  window.LumiInit = window.LumiInit || [];
  ALL.forEach(function(fn){ window.LumiInit.push(fn); fn(document); });
})();

/* Lumi part 4 (26 Sep 2026): the ending. The founders as leaning scrapbook cards, the reserve band's waitlist Lumi
   who watches you type and cheers when you join, FAQ faces that wake up when an answer opens, the footer Lumi who
   falls asleep at the very bottom of the page, the story page hero Lumi, and the reserve page gallery that floods
   with the colour you pick. No libraries.
   Every init runs inside a root element and marks what it has set up, so Shopify's theme editor can re-run it for
   a re-rendered section. Lumi is drawn inline here (the same drawing as the sprite at the top of index.html), so
   story, reserve and the theme work without that sprite. Anything missing on a page is simply skipped. */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s,r){return (r||document).querySelector(s)};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var within = function(root, sel){ var out = $$(sel, root); if (root.matches && root.matches(sel)) out.unshift(root); return out; };
  var buzz = function(ms){ if (!navigator.vibrate) return; if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return; try{navigator.vibrate(ms)}catch(e){} };
  var safe = function(fn){ return function(root){ try { fn(root || document); } catch(e){ if (window.console) console.warn('lumi:', e); } }; };
  var again = function(el, cls){ if (!el || reduce) return; el.classList.remove(cls); void el.getBoundingClientRect(); el.classList.add(cls); };
  /* one body move at a time: hop, nod, shake, wave or wig (a leftover class would otherwise win over the next one) */
  var MOVES = ['hop', 'nod', 'shake', 'wave', 'wig'];
  var move = function(el, cls){ if (!el || reduce) return; MOVES.forEach(function(c){ el.classList.remove(c); }); again(el, cls); };

  /* ---- Lumi's faces, 120 x 80, the same as the hero sprite, plus two new ones for the footer: sleepy and asleep ---- */
  var INK = '#13223A';
  var CHEEK = function(y, r, o){ return '<g fill="#F2BFCF" opacity="' + (o || '.85') + '"><circle cx="21" cy="' + y + '" r="' + r + '"/><circle cx="99" cy="' + y + '" r="' + r + '"/></g>'; };
  var F = {
    idle: CHEEK(51, 8) + '<g fill="' + INK + '"><circle cx="40" cy="35" r="7.5"/><circle cx="80" cy="35" r="7.5"/></g><g fill="#FFFDF9"><circle cx="42.8" cy="32.2" r="2.4"/><circle cx="82.8" cy="32.2" r="2.4"/></g><path d="M50 48q10 9 20 0" fill="none" stroke="' + INK + '" stroke-width="4.6" stroke-linecap="round"/>',
    blink: CHEEK(51, 8) + '<path d="M31 36q9 6 18 0M71 36q9 6 18 0" fill="none" stroke="' + INK + '" stroke-width="4.6" stroke-linecap="round"/><path d="M50 48q10 9 20 0" fill="none" stroke="' + INK + '" stroke-width="4.6" stroke-linecap="round"/>',
    ready: '<g fill="#F2BFCF" opacity=".85"><circle cx="20" cy="51" r="8.5"/><circle cx="100" cy="51" r="8.5"/></g><g fill="' + INK + '"><circle cx="39" cy="33" r="9"/><circle cx="81" cy="33" r="9"/></g><g fill="#FFFDF9"><circle cx="42.2" cy="29.8" r="3"/><circle cx="84.2" cy="29.8" r="3"/></g><path d="M48 46q12 15 24 0z" fill="' + INK + '" stroke="' + INK + '" stroke-width="3" stroke-linejoin="round"/>',
    done: '<g fill="#F2BFCF" opacity=".9"><circle cx="20" cy="50" r="9"/><circle cx="100" cy="50" r="9"/></g><path d="M29 39q11-14 22 0M69 39q11-14 22 0" fill="none" stroke="' + INK + '" stroke-width="5.2" stroke-linecap="round"/><path d="M45 46q15 19 30 0z" fill="' + INK + '" stroke="' + INK + '" stroke-width="3" stroke-linejoin="round"/><g fill="#F5A623" stroke="' + INK + '" stroke-width="1.2" stroke-linejoin="round"><path d="M12 5l2.4 5.6 5.6 2.4-5.6 2.4L12 21l-2.4-5.6L4 13l5.6-2.4z"/><path d="M108 8l2 4.6 4.6 2-4.6 2-2 4.6-2-4.6-4.6-2 4.6-2z"/></g>',
    watch: CHEEK(52, 8) + '<g fill="' + INK + '"><circle cx="34" cy="40" r="8"/><circle cx="74" cy="40" r="8"/></g><g fill="#FFFDF9"><circle cx="36.8" cy="37.2" r="2.6"/><circle cx="76.8" cy="37.2" r="2.6"/></g><path d="M50 53q8 6 16 0" fill="none" stroke="' + INK + '" stroke-width="4.6" stroke-linecap="round"/>',
    side: CHEEK(51, 8) + '<g fill="' + INK + '"><circle cx="47" cy="35" r="7.5"/><circle cx="87" cy="35" r="7.5"/></g><g fill="#FFFDF9"><circle cx="49.8" cy="32.2" r="2.4"/><circle cx="89.8" cy="32.2" r="2.4"/></g><path d="M56 48q9 7 18 0" fill="none" stroke="' + INK + '" stroke-width="4.6" stroke-linecap="round"/>',
    notice: '<g fill="#F2BFCF" opacity=".85"><circle cx="20" cy="52" r="8"/><circle cx="100" cy="52" r="8"/></g><g fill="' + INK + '"><circle cx="40" cy="34" r="10"/><circle cx="80" cy="34" r="10"/></g><g fill="#FFFDF9"><circle cx="44" cy="30" r="3.3"/><circle cx="84" cy="30" r="3.3"/></g><circle cx="60" cy="56" r="5" fill="none" stroke="' + INK + '" stroke-width="4.2"/>',
    /* heavy lids: half-closed eyes and a small flat mouth */
    sleepy: CHEEK(52, 7.5, '.8') + '<path d="M31 37a9 8 0 0 0 18 0zM71 37a9 8 0 0 0 18 0z" fill="' + INK + '"/><path d="M29.5 36.5q10.5 2.5 21 0M69.5 36.5q10.5 2.5 21 0" fill="none" stroke="' + INK + '" stroke-width="4" stroke-linecap="round"/><ellipse cx="60" cy="54" rx="3.2" ry="3.8" fill="' + INK + '"/>',
    /* fast asleep: soft closed eyes low on the face and a little round snoring mouth */
    asleep: CHEEK(53, 7.5, '.75') + '<path d="M31 40q9 5.5 18 0M71 40q9 5.5 18 0" fill="none" stroke="' + INK + '" stroke-width="4.6" stroke-linecap="round"/><ellipse cx="60" cy="55" rx="4.4" ry="3.6" fill="' + INK + '"/>'
  };
  var GLASS = '<rect width="120" height="80" rx="18" fill="#E3EBF3"/><path d="M84 0h14L60 80H46z" fill="#FFFDF9" opacity=".5"/>';
  var SHELL = '<g stroke="#2E2A24" stroke-width="3" stroke-linejoin="round" style="fill:var(--lumi-body,#EBD7BF)"><circle cx="50" cy="10" r="6.4" fill="none" stroke-width="7.4"/><circle cx="50" cy="10" r="6.4" fill="none" style="stroke:var(--lumi-body,#EBD7BF)" stroke-width="2.6"/><ellipse class="arm-l" cx="10" cy="70" rx="7.6" ry="13.5" transform="rotate(20 10 70)"/><ellipse class="arm-r" cx="90" cy="70" rx="7.6" ry="13.5" transform="rotate(-20 90 70)"/><ellipse cx="34" cy="113" rx="11.5" ry="8"/><ellipse cx="66" cy="113" rx="11.5" ry="8"/><path d="M50 15C75 15 86 32 86 54L87 94C87 109 72 116 50 116C28 116 13 109 13 94L14 54C14 32 25 15 50 15Z"/><rect x="24.5" y="35.5" width="51" height="36" rx="11" fill="#2E2A24" style="fill:#2E2A24"/><circle cx="50" cy="91" r="9.5" fill="none" style="fill:none" stroke="#E2B35E" stroke-width="3"/><circle cx="50" cy="91" r="5" fill="none" style="fill:none" stroke="#2E2A24" stroke-opacity=".22" stroke-width="1.5"/></g>';
  var STAR = 'M10 1.5c.8 4.6 3.9 7.7 8.5 8.5-4.6.8-7.7 3.9-8.5 8.5-.8-4.6-3.9-7.7-8.5-8.5 4.6-.8 7.7-3.9 8.5-8.5z';
  function faces(list){ return list.map(function(k){ return '<g class="fc fc-' + k + '">' + F[k] + '</g>'; }).join(''); }
  /* a screen face in its dark bezel, 132 x 92 */
  function screen(list){ return '<svg viewBox="0 0 132 92" aria-hidden="true"><rect x="2" y="2" width="128" height="88" rx="24" fill="#2E2A24"/><svg x="9" y="8" width="114" height="76" viewBox="0 0 120 80">' + GLASS + faces(list) + '</svg></svg>'; }
  /* the whole flat Lumi, 100 x 124; ring adds a belly ring that can fill (.lr-p, styled in middle.css) */
  function body(list, ring){ return '<svg class="lumi-svg" viewBox="0 0 100 124" aria-hidden="true">' + SHELL + '<svg x="27.5" y="38.5" width="45" height="30" viewBox="0 0 120 80">' + GLASS + faces(list) + '</svg>' + (ring ? '<circle class="lr-p" cx="50" cy="91" r="9.5" pathLength="100" transform="rotate(-90 50 91)"/>' : '') + '</svg>'; }
  function star(cls, fill){ return '<svg class="' + cls + '" viewBox="0 0 20 20" aria-hidden="true"><path d="' + STAR + '" fill="' + (fill || '#F5A623') + '" stroke="#2E2A24" stroke-width="1.5" stroke-linejoin="round"/></svg>'; }

  /* blink now and then while on screen, unless something else is driving the face (el.__busy) */
  function blinker(el){
    if (reduce || el.__lumiBlinker) return; el.__lumiBlinker = 1;
    var vis = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ vis = es[0].isIntersecting; }).observe(el);
    (function loop(){
      setTimeout(function(){
        if (vis && !document.hidden && !el.__busy){
          el.setAttribute('data-blink', '');
          setTimeout(function(){ el.removeAttribute('data-blink'); }, 150);
        }
        loop();
      }, 2300 + Math.random() * 3600);
    })();
  }
  /* a little burst of confetti out of an element (stars and chips in the tints), gone after a second */
  var CONF = ['#F5A623', '#E86B78', '#4C9BE8', '#4CB878', '#8E7CF3', '#FFFDF9'];
  function confetti(host, n){
    if (reduce || !host) return;
    var box = document.createElement('span'); box.className = 'lu-conf'; box.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < n; i++){
      var s = document.createElement('i'), a = (i / n) * Math.PI * 2 + Math.random() * .5, d = 60 + Math.random() * 70;
      s.style.setProperty('--dx', Math.round(Math.cos(a) * d) + 'px');
      s.style.setProperty('--dy', Math.round(Math.sin(a) * d * .8 - 40) + 'px');
      s.style.setProperty('--r', Math.round(Math.random() * 540 - 270) + 'deg');
      s.style.background = CONF[i % CONF.length];
      if (i % 3 === 0) s.className = 'st';
      box.appendChild(s);
    }
    host.appendChild(box);
    setTimeout(function(){ if (box.parentNode) box.parentNode.removeChild(box); }, 1300);
  }

  /* ---- FOUNDERS: two leaning scrapbook cards; Lumi next to them says who is who when you hover or tap ---- */
  var initFounders = safe(function(root){
    within(root, '[data-founders]').forEach(function(sec){
      if (sec.__lumiFounders) return; sec.__lumiFounders = 1;
      $$('.fd-lumi', sec).forEach(function(l){ l.innerHTML = body(['idle', 'blink', 'done', 'ready']); l.setAttribute('data-face', 'idle'); blinker(l); });
      var host = $('.fd-host-lumi', sec), say = $('[data-fd-say]', sec), rest = say ? say.textContent : '', t = 0;
      if (host){ host.innerHTML = body(['idle', 'blink', 'side', 'ready', 'done']); host.setAttribute('data-face', 'idle'); blinker(host); }
      function tell(card, tapped){
        clearTimeout(t);
        if (host){ host.__busy = 1; host.setAttribute('data-face', tapped ? 'done' : 'side'); host.classList.add('look-l'); if (tapped) move(host, 'hop'); }
        if (say && card){ say.textContent = card.getAttribute('data-say') || rest; again(say.parentNode, 'pop'); }
      }
      function calm(){
        t = setTimeout(function(){
          if (host){ host.__busy = 0; host.setAttribute('data-face', 'idle'); host.classList.remove('look-l'); }
          if (say){ say.textContent = rest; }
        }, 700);
      }
      $$('.fd-card', sec).forEach(function(card){
        var mini = $('.fd-lumi', card), mt = 0;
        card.addEventListener('mouseenter', function(){ tell(card, false); if (mini){ mini.__busy = 1; mini.setAttribute('data-face', 'ready'); } });
        card.addEventListener('mouseleave', function(){ calm(); if (mini){ mini.__busy = 0; mini.setAttribute('data-face', 'idle'); } });
        card.addEventListener('focus', function(){ tell(card, false); });
        card.addEventListener('blur', calm);
        function tap(){
          tell(card, true); move(card, 'wig'); buzz(8);
          if (mini){ mini.__busy = 1; mini.setAttribute('data-face', 'done'); move(mini, 'hop'); clearTimeout(mt); mt = setTimeout(function(){ mini.__busy = 0; mini.setAttribute('data-face', 'idle'); }, 1500); }
          calm();
        }
        card.addEventListener('click', tap);
        card.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); tap(); } });
      });
    });
  });

  /* ---- RESERVE BAND: the waitlist Lumi watches you type, the ring fills as the address takes shape, and Lumi cheers
     when you join. The waitlist code at the end of this file fires 'lumi:wl' with {ok:true} after a good submit. ---- */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var initWaitlist = safe(function(root){
    within(root, '[data-wl]').forEach(function(zone){
      if (zone.__lumiWl) return; zone.__lumiWl = 1;
      var lumi = $('.wl-lumi', zone), inp = $('input[type=email]', zone), say = $('[data-wl-say]', zone), form = $('form', zone);
      if (!lumi || !inp) return;
      lumi.innerHTML = body(['idle', 'blink', 'side', 'ready', 'watch', 'done'], true);
      lumi.setAttribute('data-face', 'idle'); blinker(lumi);
      var ring = $('.lr-p', lumi), lines = {
        rest: say ? say.textContent : '',
        focus: zone.getAttribute('data-say-focus') || 'Ooh, go on.',
        typing: zone.getAttribute('data-say-typing') || 'Keep going...',
        good: zone.getAttribute('data-say-good') || 'That looks right!',
        oops: zone.getAttribute('data-say-oops') || 'Hmm, is that an email?',
        empty: zone.getAttribute('data-say-empty') || 'Pop your email in first.',
        joined: zone.getAttribute('data-say-joined') || "You're in! Yay!"
      }, joinedT = 0, last = '', oopsAt = 0, burst = $('.wl-burst', zone);
      function line(k){ if (!say) return; var s = lines[k]; if (s === last) return; last = s; say.textContent = s; again(say.parentNode, 'pop'); }
      function face(f){ lumi.setAttribute('data-face', f); }
      function fill(){
        var v = inp.value.trim(), ok = EMAIL.test(v);
        var p = ok ? 100 : Math.min(88, v.length * 5.5);
        if (ring) ring.style.strokeDashoffset = (100 - p).toFixed(1);
        zone.classList.toggle('wl-full', ok);
        return {v: v, ok: ok};
      }
      inp.addEventListener('focus', function(){ lumi.__busy = 1; if (Date.now() - oopsAt < 600) return; var s = fill(); face(s.ok ? 'ready' : s.v ? 'side' : 'ready'); line(s.ok ? 'good' : s.v ? 'typing' : 'focus'); });
      inp.addEventListener('input', function(){
        var s = fill(); lumi.__busy = 1; oopsAt = 0;
        if (s.ok){ if (lumi.getAttribute('data-face') !== 'ready'){ face('ready'); move(lumi, 'hop'); } line('good'); }
        else if (s.v){ face('side'); line('typing'); move(lumi, 'nod'); }
        else { face('ready'); line('focus'); }
      });
      inp.addEventListener('blur', function(){ setTimeout(function(){ if (document.activeElement === inp || zone.classList.contains('wl-joined')) return; lumi.__busy = 0; var s = fill(); face(s.ok ? 'ready' : 'idle'); if (!s.v) line('rest'); }, 120); });
      inp.addEventListener('invalid', function(){ oopsAt = Date.now(); lumi.__busy = 1; face('watch'); line(inp.value.trim() ? 'oops' : 'empty'); move(lumi, 'shake'); });
      if (form) form.addEventListener('lumi:wl', function(e){
        if (!e.detail || !e.detail.ok) return;
        lines.joined = zone.getAttribute('data-say-joined') || lines.joined;
        clearTimeout(joinedT); lumi.__busy = 1;
        zone.classList.add('wl-joined'); face('done'); line('joined'); move(lumi, 'hop'); confetti(lumi, 24); again(burst, 'pop');
        if (ring) ring.style.strokeDashoffset = '0';
        inp.placeholder = zone.getAttribute('data-placeholder-again') || 'Add another email?';
        joinedT = setTimeout(function(){ zone.classList.remove('wl-full'); face('ready'); lumi.__busy = 0; if (ring) ring.style.strokeDashoffset = '100'; }, 3200);
      });
      fill();
    });
  });

  /* ---- FAQ: every question carries a small Lumi face that is dozing while closed and wakes up with its own
     expression when you open it; the Lumi beside the heading (if there is one) reacts too. One answer open at a time. ---- */
  var initFaq = safe(function(root){
    within(root, '.faq').forEach(function(faq){
      if (faq.__lumiFaq) return; faq.__lumiFaq = 1;
      var sec = faq.closest('section') || faq.parentNode, host = $('.faq-lumi-body', sec), say = $('[data-faq-say]', sec);
      var rest = say ? say.textContent : '', items = $$('details', faq), ht = 0;
      /* 27 Sep: real Lumi faces. The host is the real render (in the markup); row chips clone the template tiles */
      var tpl = $('template[data-rface]', sec);
      if (host){ if (!$('.rl-body', host)) host.innerHTML = body(['idle', 'blink', 'ready', 'done', 'watch', 'side', 'notice']); host.setAttribute('data-face', 'idle'); blinker(host); }
      items.forEach(function(d, i){
        var sum = $('summary', d); if (!sum || $('.fq-face', sum)) return;
        var chip = document.createElement('span'); chip.className = 'fq-face'; chip.setAttribute('aria-hidden', 'true');
        var mood = d.getAttribute('data-fq-face') || ['ready', 'watch', 'done', 'side', 'notice'][i % 5];
        if (tpl){ chip.className = 'fq-face rface'; chip.innerHTML = tpl.innerHTML; } else chip.innerHTML = screen(['idle', 'blink', mood]);
        chip.setAttribute('data-face', d.open ? mood : 'idle');
        sum.appendChild(chip); sum.classList.add('has-face');
        d.addEventListener('toggle', function(){
          chip.setAttribute('data-face', d.open ? mood : 'idle');
          if (!d.open) return;
          again(chip, 'pop');
          items.forEach(function(o){ if (o !== d && o.open) o.open = false; });
          if (host){
            clearTimeout(ht); host.__busy = 1; host.setAttribute('data-face', mood); move(host, 'hop');
            ht = setTimeout(function(){ host.__busy = 0; host.setAttribute('data-face', 'idle'); }, 2600);
          }
          if (say){ say.textContent = d.getAttribute('data-fq-say') || rest; again(say.parentNode, 'pop'); }
        });
      });
    });
  });

  /* ---- FOOTER: Lumi dozes off as you reach the end of the page and is fast asleep at the very bottom.
     Scroll back up and Lumi wakes; tap and Lumi mumbles, then nods off again. ---- */
  var initNap = safe(function(root){
    within(root, '[data-nap]').forEach(function(nap){
      if (nap.__lumiNap) return; nap.__lumiNap = 1;
      var foot = nap.closest('footer') || nap.parentNode, sub = $('[data-nap-sub]', foot);
      var fig = document.createElement('span'); fig.className = 'nap-fig';
      fig.innerHTML = '<svg class="nap-cloud" viewBox="0 0 200 70" aria-hidden="true"><path d="M26 62C8 62 4 40 20 34 18 18 38 10 50 20 56 4 84 2 92 18 102 6 128 8 132 26 146 16 170 22 168 38 190 38 196 62 176 62Z" fill="#FFFDF9" stroke="#2E2A24" stroke-width="3" stroke-linejoin="round"/></svg><span class="nap-lumi" data-face="idle">' + body(['idle', 'blink', 'sleepy', 'asleep', 'watch']) + '</span><span class="nap-z" aria-hidden="true"><i>z</i><i>z</i><i>Z</i></span>';
      nap.appendChild(fig);
      var lumi = $('.nap-lumi', fig), state = '', wokeT = 0, woke = false;
      blinker(lumi);
      var lines = {
        awake: nap.getAttribute('data-say-awake') || (sub ? sub.textContent : ''),
        sleepy: nap.getAttribute('data-say-sleepy') || 'Lumi is getting sleepy...',
        asleep: nap.getAttribute('data-say-asleep') || (sub ? sub.textContent : ''),
        poked: nap.getAttribute('data-say-poked') || 'Mmh? Five more minutes.'
      };
      function set(s){
        if (woke || s === state) return; state = s;
        nap.setAttribute('data-nap', s);
        lumi.__busy = s !== 'awake';
        lumi.setAttribute('data-face', s === 'asleep' ? 'asleep' : s === 'sleepy' ? 'sleepy' : 'idle');
        if (sub && lines[s]) sub.textContent = lines[s];
      }
      function check(){
        var r = foot.getBoundingClientRect(), vh = window.innerHeight;
        var doc = document.documentElement, atEnd = window.scrollY + vh >= doc.scrollHeight - 48;
        if (r.top > vh) set('awake');
        else if (atEnd || r.bottom <= vh + 4) set('asleep');
        else if (r.top < vh * .7) set('sleepy');
        else set('awake');
      }
      var rq = 0;
      window.addEventListener('scroll', function(){ if (rq) return; rq = requestAnimationFrame(function(){ rq = 0; check(); }); }, {passive:true});
      window.addEventListener('resize', check);
      check();
      /* short pages (reserve, story at some widths) start at the end: let Lumi settle first, then doze */
      setTimeout(check, 400);
      fig.addEventListener('click', function(){
        if (state !== 'asleep' && state !== 'sleepy') { move(lumi, 'hop'); return; }
        clearTimeout(wokeT); woke = true; lumi.setAttribute('data-face', 'watch'); nap.setAttribute('data-nap', 'poked'); move(lumi, 'hop'); buzz(8);
        if (sub) sub.textContent = lines.poked;
        wokeT = setTimeout(function(){ woke = false; state = ''; check(); }, 2200);
      });
    });
  });

  /* ---- STORY HERO: a big Lumi who says hi, waves when you hover or tap, and blinks ---- */
  var initStoryHero = safe(function(root){
    within(root, '[data-sh-lumi]').forEach(function(el){
      if (el.__lumiSh) return; el.__lumiSh = 1;
      var fig = $('.sh-fig', el) || el, say = $('[data-sh-say]', el), rest = say ? say.textContent : '', t = 0;
      fig.innerHTML = body(['idle', 'blink', 'ready', 'done']);
      fig.setAttribute('data-face', 'idle'); blinker(fig);
      function hi(big){
        clearTimeout(t); fig.__busy = 1; fig.setAttribute('data-face', big ? 'done' : 'ready');
        move(fig, big ? 'hop' : 'wave');
        if (say && big){ say.textContent = el.getAttribute('data-say-tap') || rest; again(say.parentNode, 'pop'); }
        t = setTimeout(function(){ fig.__busy = 0; fig.setAttribute('data-face', 'idle'); if (say) say.textContent = rest; }, 1600);
      }
      el.addEventListener('mouseenter', function(){ hi(false); });
      el.addEventListener('click', function(){ hi(true); buzz(8); });
      el.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); hi(true); } });
    });
  });

  /* ---- RESERVE PAGE: the gallery floods with the colour you pick, and Lumi's bubble says a line about it.
     app.js still swaps the render, the name and the order form; this listens for its 'lumi:colour' event. ---- */
  var initGalleryFlood = safe(function(root){
    within(root, '[data-g-flood]').forEach(function(g){
      if (g.__lumiG) return; g.__lumiG = 1;
      var scope = g.closest('[data-colour-scope]') || document, wipe = $('.flood-wipe', g), face = $('.g-face', g), line = $('[data-g-line]', g);
      var cur = (g.style.getPropertyValue('--g') || '').trim().toUpperCase(), t1 = 0, ft = 0;
      if (face){ if (!$('img', face)) face.innerHTML = screen(['idle', 'blink', 'ready', 'done', 'watch', 'side']); face.setAttribute('data-face', 'idle'); blinker(face); }
      scope.addEventListener('lumi:colour', function(e){
        var sw = e.detail && e.detail.swatch; if (!sw) return;
        if (line && sw.getAttribute('data-line')){ line.textContent = sw.getAttribute('data-line'); again(line.parentNode, 'pop'); }
        if (face){ clearTimeout(ft); face.__busy = 1; face.setAttribute('data-face', 'done'); again(face, 'pop'); ft = setTimeout(function(){ face.setAttribute('data-face', sw.getAttribute('data-mood') || 'ready'); face.__busy = 0; }, 1400); }
        var col = (sw.getAttribute('data-flood') || '').toUpperCase();
        if (!col || col === cur) return;
        cur = col; clearTimeout(t1);
        if (reduce || !wipe){ g.style.setProperty('--g', col); return; }
        var gr = g.getBoundingClientRect();
        wipe.classList.remove('go');
        wipe.style.setProperty('--wipe', col); wipe.style.setProperty('--wx', '50%'); wipe.style.setProperty('--wy', '100%'); wipe.style.setProperty('--wr', Math.ceil(Math.hypot(gr.width / 2, gr.height)) + 20 + 'px');
        void wipe.getBoundingClientRect(); wipe.classList.add('go');
        t1 = setTimeout(function(){ g.style.setProperty('--g', col); wipe.classList.remove('go'); }, 820);
      });
      var buy = $('.buybox .btn');
      if (buy && face && line){
        var rest = '';
        buy.addEventListener('mouseenter', function(){ rest = line.textContent; face.__busy = 1; face.setAttribute('data-face', 'ready'); line.textContent = g.getAttribute('data-say-buy') || 'Go on. It is refundable.'; again(line.parentNode, 'pop'); });
        buy.addEventListener('mouseleave', function(){ face.__busy = 0; face.setAttribute('data-face', 'idle'); if (rest) line.textContent = rest; });
      }
    });
  });

  var ALL = [initFounders, initWaitlist, initFaq, initNap, initStoryHero, initGalleryFlood];
  window.LumiInit = window.LumiInit || [];
  ALL.forEach(function(fn){ window.LumiInit.push(fn); fn(document); });
})();

/* 9 Oct 2026 (replaces the 8 Oct block): the waitlist sheet and every Shopify customer (waitlist) form.
   - window.LumiWl = {open, close, isOpen, el}. Events on document: lumi:wl-open {auto}, lumi:wl-close {how, auto},
     lumi:wl-submit {form, email, rec} (synchronous, so listeners can add to rec and to the form's tags),
     lumi:wl-done {rec, reload, existing, form}, lumi:wl-error {rec}.
   - Submit: while Shopify's storefront captcha is on, its own hCaptcha handler makes the one native POST, so this code
     only writes sessionStorage lumiWlPending and lets it go (the 8 Oct quiet fetch raced that handler). With no captcha
     on the form it still posts quietly with fetch and falls back to a native post.
   - The result is read from the URL Shopify comes back to: customer_posted=true is a sign-up; a form that renders
     [data-form-errors] is an error; form_type=customer without either is an address Shopify already had.
   - The sheet moves to <body> on first open; while open the page behind is inert (header group, #main, footer group
     only, never Shopify's cookie banner or hCaptcha), Tab stays in the card unless the cookie banner shows, Escape
     closes unless the cookie preferences dialog is open, and focus goes back where it was. */
(function () {
  if (!window.LumiDraw) document.documentElement.classList.remove('lumi-draw'); /* the draw script did not run: never show the draw */
  var SHEET = 'wl-sheet', EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, PKEY = 'lumiWlPending', MAXAGE = 15 * 60 * 1000;
  var lastFocus = null, inerted = [], openedAt = 0;
  /* one sheet only (a template could render the snippet twice) */
  var all = document.querySelectorAll('#' + SHEET);
  for (var k = 1; k < all.length; k++) all[k].parentNode.removeChild(all[k]);

  function ss(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      if (val === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, val);
    } catch (x) {}
    return null;
  }
  function emit(name, detail) {
    var ev;
    try { ev = new CustomEvent(name, { detail: detail || {} }); }
    catch (x) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent(name, false, false, detail || {}); }
    document.dispatchEvent(ev);
  }
  function sheet() { return document.getElementById(SHEET); }
  function card() { var s = sheet(); return s && s.querySelector('.wls-card'); }
  function isOpen() { var s = sheet(); return !!(s && s.classList.contains('on')); }
  function shown(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && el.getClientRects().length > 0;
  }
  function prefsOpen() { return shown(document.getElementById('shopify-pc__prefs')); }
  function bannerShown() { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pc-h')); return v > 0; }
  function setInert(on) {
    if (on) {
      var s = sheet();
      inerted = Array.prototype.filter.call(
        document.querySelectorAll('.shopify-section-group-header-group, #main, .shopify-section-group-footer-group'),
        function (n) { return !n.contains(s); });
    }
    inerted.forEach(function (n) {
      if ('inert' in n) n.inert = on;
      else if (on) n.setAttribute('aria-hidden', 'true'); else n.removeAttribute('aria-hidden');
    });
    if (!on) inerted = [];
  }
  function focusables() {
    var c = card(); if (!c) return [];
    return Array.prototype.filter.call(
      c.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),textarea,select'),
      function (n) { return n.getClientRects().length > 0 && getComputedStyle(n).visibility !== 'hidden'; });
  }
  function showErr(on) {
    var s = sheet(); if (!s) return;
    var er = s.querySelector('.wls-err');
    if (er) er.classList.toggle('on', !!on);
  }
  function open(opts) {
    opts = opts || {};
    var s = sheet(); if (!s) return false;
    if (s.parentNode !== document.body) document.body.appendChild(s);
    if (opts.state === 'done') { s.classList.add('done'); showErr(false); }
    if (opts.state === 'error') { s.classList.remove('done'); showErr(true); }
    if (opts.state === 'form') { s.classList.remove('done'); showErr(false); }
    if (!isOpen()) {
      lastFocus = opts.opener || document.activeElement;
      s.hidden = false; void s.offsetWidth;
      s.classList.add('on'); document.documentElement.classList.add('wls-open');
      setInert(true); openedAt = Date.now(); s.__auto = !!opts.auto;
      emit('lumi:wl-open', { auto: !!opts.auto, state: opts.state || '' });
    }
    setTimeout(function () {
      var i = s.querySelector('input[type=email]');
      var formShowing = !s.classList.contains('done') && !s.classList.contains('joined');
      if (opts.focus === 'email' && i && formShowing) {
        i.focus();
        var c = card(), fm = i.form;
        if (c && fm && c.scrollHeight > c.clientHeight) { var need = fm.offsetTop + fm.offsetHeight + 8 - c.clientHeight; if (need > c.scrollTop) c.scrollTop = need; }
      }
      else try { s.focus({ preventScroll: true }); } catch (x) { s.focus(); }
    }, 80);
    return true;
  }
  function close(how) {
    var s = sheet(); if (!s || !isOpen()) return;
    s.classList.remove('on'); document.documentElement.classList.remove('wls-open'); setInert(false);
    setTimeout(function () { if (!s.classList.contains('on')) s.hidden = true; }, 320);
    var back = lastFocus; lastFocus = null;
    emit('lumi:wl-close', { how: how || '', auto: !!s.__auto });
    if (back && back.focus && document.documentElement.contains(back) && back !== document.body) {
      try { back.focus({ preventScroll: true }); } catch (x) {}
    }
  }
  window.LumiWl = { open: open, close: close, isOpen: isOpen, el: sheet };

  /* theme editor: a re-rendered section brings its own sheet; keep only the fresh one */
  document.addEventListener('shopify:section:load', function (e) {
    var fresh = e.target && e.target.querySelector ? e.target.querySelector('#' + SHEET) : null;
    if (!fresh) return;
    if (isOpen()) close('editor');
    Array.prototype.forEach.call(document.querySelectorAll('#' + SHEET), function (n) { if (n !== fresh && n.parentNode) n.parentNode.removeChild(n); });
  });
  document.addEventListener('shopify:section:unload', function () { if (isOpen()) close('editor'); });

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var o = t.closest('[data-wl-open]');
    if (o) { if (open({ focus: 'email', opener: o })) e.preventDefault(); return; }
    var c = t.closest('[data-wl-close]');
    if (c) {
      var s = sheet(), bg = c.classList.contains('wls-bg');
      e.preventDefault();
      /* a tap that lands on the backdrop just after an automatic open, or on a friend's sheet, does not close it */
      if (bg && s && (s.getAttribute('data-backdrop') === 'off' || (s.__auto && Date.now() - openedAt < 700))) return;
      close(bg ? 'backdrop' : (c.classList.contains('wls-x') ? 'x' : 'link'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape' || e.key === 'Esc') { if (!prefsOpen()) close('escape'); return; }
    if (e.key !== 'Tab' || prefsOpen() || bannerShown()) return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement, s = sheet();
    if (e.shiftKey && (a === first || a === s)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !card().contains(a))) { e.preventDefault(); first.focus(); }
  });

  function isWl(f) {
    var t = f.querySelector('input[name="form_type"]');
    return !!(t && t.value === 'customer' && f.querySelector('input[name="contact[email]"]'));
  }
  function captchaBound(f) {
    return f.getAttribute('data-hcaptcha-bound') === 'true' || f.hasAttribute('data-cptcha') ||
      !!f.querySelector('.h-captcha, iframe[src*="hcaptcha"]');
  }
  function srcOf(f) {
    var s = f.closest('#' + SHEET);
    if (s) return 'sheet-' + (s.getAttribute('data-src') || 'home');
    if (f.closest('[data-wl]')) return 'band';
    if (f.closest('.pdp-wl')) return 'product';
    return 'form';
  }
  function native(f) {
    f.__wlNative = 1;
    if (f.requestSubmit) f.requestSubmit(); else f.submit();
  }
  /* kind: 'done' or 'error'; f = the form for a quiet (fetch) result, null after a reload */
  function result(rec, kind, existing, f) {
    ss(PKEY, null);
    var s = sheet();
    if (kind === 'error') {
      if (rec.sheet && s) open({ state: 'error' });
      emit('lumi:wl-error', { rec: rec });
      return;
    }
    if (rec.sheet && s) {
      if (isOpen()) { s.classList.add('done'); showErr(false); setTimeout(function () { try { s.focus({ preventScroll: true }); } catch (x) {} }, 0); }
      else open({ state: 'done' });
    }
    if (f) {
      var z = f.closest('[data-wl]'), p = f.closest('.pdp-wl');
      if (z) { try { f.dispatchEvent(new CustomEvent('lumi:wl', { detail: { ok: true } })); } catch (x) {} }
      if (p) p.innerHTML = '<p class="pdp-wl-ok" role="status">You\'re on the list. Thanks for joining.</p><p class="pdp-wl-sub">We write when there\'s news, not every week.</p>';
      var i = f.querySelector('input[type=email]'); if (i && !p) i.value = '';
    }
    emit('lumi:wl-done', { rec: rec, reload: !f, existing: !!existing, form: f || null });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || !isWl(f) || f.__wlNative) return;
    var inp = f.querySelector('input[type=email]');
    if (!inp || !EMAIL.test(inp.value.trim())) return; /* the browser shows its own message */
    var rec = { t: Date.now(), src: srcOf(f), sheet: !!f.closest('#' + SHEET), form: f.id || '' };
    emit('lumi:wl-submit', { form: f, email: inp.value.trim(), rec: rec });
    ss(PKEY, JSON.stringify(rec));
    if (captchaBound(f) || !window.fetch || !window.FormData || !window.DOMParser) return; /* Shopify posts it */
    e.preventDefault();
    var btn = f.querySelector('button'), lbl = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'One sec…'; }
    function back() { if (btn) { btn.disabled = false; btn.innerHTML = lbl; } }
    fetch(f.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(f), credentials: 'same-origin', redirect: 'follow', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text().then(function (t) { return { r: r, t: t }; }); })
      .then(function (x) {
        back();
        var u = x.r.url || '';
        if ((x.r.status === 400 && /captcha/i.test(x.t)) || /challenge/i.test(u)) { native(f); return; }
        if (!x.r.ok) { native(f); return; }
        if (/[?&]customer_posted=true/.test(u)) { result(rec, 'done', false, f); return; }
        var same = null;
        try { same = f.id ? new DOMParser().parseFromString(x.t, 'text/html').getElementById(f.id) : null; } catch (y) {}
        var zs = same && (same.closest('[data-wl]') || same.closest('.pdp-wl'));
        if (same && (same.querySelector('[data-form-errors], .errors') || (zs && zs.querySelector('.errors')))) { if (rec.sheet) result(rec, 'error', false, f); else native(f); return; }
        if (/[?&]form_type=customer/.test(u)) { result(rec, 'done', true, f); return; }
        native(f);
      })
      .catch(function () { back(); native(f); });
  }, true);

  /* the page Shopify came back to after a native post (or the captcha challenge) */
  (function () {
    var rec = null, raw = ss(PKEY), q = location.search;
    try { rec = raw ? JSON.parse(raw) : null; } catch (x) {}
    if (!rec && /[?&]customer_posted=true/.test(q) && ss('lumiWlSheet') === '1') rec = { t: Date.now(), src: 'sheet-home', sheet: true, form: 'sheet-waitlist-form' };
    /* storage lost across the captcha (some in-app browsers): Shopify keeps the form id in the hash */
    var nt = ''; try { var ne = performance.getEntriesByType('navigation')[0]; nt = ne ? ne.type : ''; } catch (x) {}
    if (!rec && nt !== 'reload' && nt !== 'back_forward' && /[?&]customer_posted=true/.test(q) && location.hash === '#sheet-waitlist-form') rec = { t: Date.now(), src: 'sheet', sheet: true, form: 'sheet-waitlist-form', lost: true };
    ss('lumiWlSheet', null);
    if (!rec) return;
    if (!rec.t || Date.now() - rec.t > MAXAGE) { ss(PKEY, null); return; }
    var f = rec.form ? document.getElementById(rec.form) : null;
    var z = f && (f.closest('[data-wl]') || f.closest('.pdp-wl'));
    if (f && (f.querySelector('[data-form-errors], .errors') || (z && z.querySelector('.errors')))) result(rec, 'error', false, null);
    else if (/[?&]customer_posted=true/.test(q)) result(rec, 'done', false, null);
    else if (/[?&]form_type=customer/.test(q)) result(rec, 'done', true, null);
    else return; /* the visitor left the captcha unfinished: keep the note until it expires */
    /* handled: take customer_posted out of the address so a refresh does not show it again */
    try {
      var clean = location.search.replace(/([?&])customer_posted=true(&|$)/, function (m, a, b) { return b ? a : ''; }).replace(/[?&]$/, '');
      history.replaceState(history.state, '', location.pathname + clean + location.hash);
    } catch (x) {}
  })();
})();
